var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from "../../../../constants/media";
import removeimage from '../../../../images/icons/longreadeditor/deleteimage.svg';
import removeimagehover from '../../../../images/icons/longreadeditor/deleteimagehover.svg';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import { updateLongReadPost } from '../../../../actions/updateLongReadPost';
import { deleteLongReadPost } from '../../../../actions/deleteLongReadPost';
import { colorObj } from '../../../../constants/colorObj';
import urlApi from '../../../../actions/urlApi';
import { paddings, heights } from '../../../../constants/paddings';
import BigImageComp from './bigimage';
import ColorMenuComp from './colormenu';
import { throttle } from './throttle';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import { Endpoints } from "@brg/api";
import FileInput from '@uppy/file-input';
import EditorToolbar from './EditorToolbar';
import CaptionEdit from './CaptionEdit';
import { CaptionBlock } from '../postblocks/coloredblock';
import { CaptionMarkdownText, LeftColumn, RightColumn, TextWrapper } from "../postblocks/whitepostblock";
import TextArea, { TEXTAREA_TYPE } from '../../modules/inputs/TextArea';
import formatLinks from '../../../../utilites/formatLinks';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import toastHook from '../../../../utilites/toasts';
import { Colors, FlexBox, useToasts } from '@brg/ui';
import { EditorWrap, EditTitle } from './newel';
import { getAppNameFromAppString } from '../../../../utilites/appTester';
import { withModal } from '../../../../core/modules/modal.module';
import { withLocalization } from '../../../../hooks/useLocalization';
import { HeaderToggle } from "../postblocks/bibliographyblock";
import { getGalllleryUrl } from "../../../../actions/getGalllleryUrl";
import { FirstAsCoverBlock } from './FirstAsCover/FirstAsCoverBlock';
import VotePostBlock from '../postblocks/VoteBlock/votepostblock';
import { SliderEditBlock } from './SiderEditBlock/SliderEditBlock';
import { PresentationBlock } from './Presentation/PresentationBlock';
import { withProfile } from '../../../../hooks/withProfile';
import { bProfile } from '@brg/auth';
import { ProjectEditBlock } from "./ProjectEditBlock/ProjectEditBlock";
import Votepostwithcollect from '../postblocks/VoteBlock/votepostwithcollect';
import ButtonBlock from './Button';
import { BUTTON_TYPE, UPRISE_TYPE } from './Button/const';
import FormsBlock, { FORM_CENTER_POS } from '../postblocks/FormsBlock/FormsBlock';
import { LINK_BUTTON_TYPE } from './Button/Button';
import { getToggleLongReadPostUpdate } from "../../../../reducers/toggleLongReadPostUpdate";
import { LessonEditBlock } from "../postblocks/CourseBlock/sections/LessonEditBlock";
import ProductsBlock from '../postblocks/ProductsBlock/ProductsBlock';
import { CoursePresentationEditBlock } from "./CoursePresentationEditBlock/CoursePresentationEditBlock";
import TwoPicturesBlock from './TwoPicturesBlock/TwoPicturesBlock';
import RadioButton from "../../../buttons/Radio";
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import BigImageCard from "./bigimageCard";
import { addOrChangeAdditionalInfo } from "../../../../utilites/addOrChangeAdditionalInfo";
import { getAdditionalInfoVal } from "../../../../utilites/getAdditionalInfoVal";
import { PodcastEditBlock } from "./PodcastEditBlock/PodcastEditBlock";
import { onChangeBibliography } from '../../../../utilites/bibliography/onChangeBibliography';
import { modifyToListText } from '../../../../utilites/bibliography/modifyToListText';
import { getCardIdsFromAdditionalInfo } from '../../../../utilites/card/getCardIdsFromAdditionalInfo';
import { getIsPayFromPost } from '../../../../utilites/card/getIsPayFromPost';
import { updateIsPayInCardsInfo } from '../../../../utilites/card/updateIsPayInCardsInfo';
import { CARDS_INFO_KEY } from '../../../../constants/cards';
import { INITIAL_RAITING, RaitingBox } from '../postblocks/components/RaitingBox';
import { clearWidePreviewer, toggleWidePreviewer } from '../../../../actions/toggleWidePreviewer';
import { WhitePostImageBlock } from './WhitePostImageBlock/WhitePostImageBlock';
import LinkArea from '../../modules/inputs/LinkArea';
import { extractProjectId, replaceAWithHref } from '../../../../utilites/replaceHiddenProjectLink';
import { BlockWithTitleEdit } from './AnnotationEditor/BlockWithTitleEdit';
import { getTileViewType } from '../../../../constants/TyleViewType';
var MAX_FILES_COUNT = 15;
var Wrap = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  max-width: min-content;\n  min-width: 1152px;\n  margin-top: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  //margin-top: 40px;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  margin-bottom: ", ";\n   z-index: ", ";\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n  transition: all 1s;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    // $ {({ fixWidth }) => fixWidth ? css\n    //   max-width: 888px;\n    //  : null};\n    min-width: 888px\n  }\n\n  ", ";\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 0.5s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"], ["\n\n  max-width: min-content;\n  min-width: 1152px;\n  margin-top: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  //margin-top: 40px;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  margin-bottom: ", ";\n   z-index: ", ";\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n  transition: all 1s;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    // $ {({ fixWidth }) => fixWidth ? css\n    //   max-width: 888px;\n    //  : null};\n    min-width: 888px\n  }\n\n  ", ";\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 0.5s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"])), function (props) {
    return (props === null || props === void 0 ? void 0 : props.withHeader) ? '16px' : '40px';
}, function (props) {
    return (props === null || props === void 0 ? void 0 : props.withHeader) ? '16px' : '40px';
}, function (p) { return (p === null || p === void 0 ? void 0 : p.hideBackground) ? 'transparent' : '#ffffff'; }, function (props) {
    return props.updateStatus === 'caption' ? /*'40px'*/ '0' : '0';
}, function (props) { return props.zIndex; }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (_a) {
    var isGalllleryNewStyle = _a.isGalllleryNewStyle;
    return isGalllleryNewStyle && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "], ["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "])));
}, function (_a) {
    var hideBackground = _a.hideBackground;
    return hideBackground ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject([" margin-top: 0;"], [" margin-top: 0;"]))) : null;
});
var AttachedImageProgress = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"])), function (props) { return (props.isLoading ? 'block' : 'none'); });
var RemoveImage = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"], ["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"])), removeimage, removeimagehover);
export var UpdateHeaderToggle = styled(HeaderToggle)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width: ", ";\n  width: 100%;\n  margin-top: 40px;\n  margin-bottom: 0px;\n  color: ", ";\n  position: ", ";\n  z-index: ", ";\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    max-width: 888px;\n    margin: 40px auto 0 auto;\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 16px;\n  }\n"], ["\n  max-width: ", ";\n  width: 100%;\n  margin-top: 40px;\n  margin-bottom: 0px;\n  color: ", ";\n  position: ", ";\n  z-index: ", ";\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    max-width: 888px;\n    margin: 40px auto 0 auto;\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 16px;\n  }\n"])), function (_a) {
    var viewType = _a.viewType, isModal = _a.isModal;
    return (['fluid', 'fixed-ratio-large', 'free-type'].includes(viewType) && !isModal) ? LayoutConst.container.l + 'px' : 'none';
}, function (props) { return ((props === null || props === void 0 ? void 0 : props.isModal) ? '#FFFFFF' : (props === null || props === void 0 ? void 0 : props.colorStyle) === 'light' ? Colors.galBlack100 : Colors.geoWhite100); }, function (props) { return ((props === null || props === void 0 ? void 0 : props.isModal) ? 'relative' : 'inherit'); }, function (props) { return ((props === null || props === void 0 ? void 0 : props.isModal) ? '101' : 'auto'); }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, LayoutConst.container.s);
var AttachedImage = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  padding-right: 30px;\n\n  .image__hover {\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 30px;\n    border: 4px solid #f1db63;\n    background: linear-gradient(\n      0deg,\n      rgba(21, 21, 20, 0.47),\n      rgba(21, 21, 20, 0.47)\n    );\n    align-items: center;\n    justify-content: center;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 20px;\n    line-height: 32px;\n    text-align: center;\n    letter-spacing: -0.02em;\n    color: #fefefe;\n    cursor: pointer;\n    z-index: 10;\n    transition: 0.2s;\n  }\n\n  img:hover + .image__hover {\n    display: flex;\n  }\n\n  .image__hover:hover {\n    display: flex;\n  }\n\n  input[type='file'] {\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"], ["\n  position: relative;\n  padding-right: 30px;\n\n  .image__hover {\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 30px;\n    border: 4px solid #f1db63;\n    background: linear-gradient(\n      0deg,\n      rgba(21, 21, 20, 0.47),\n      rgba(21, 21, 20, 0.47)\n    );\n    align-items: center;\n    justify-content: center;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 20px;\n    line-height: 32px;\n    text-align: center;\n    letter-spacing: -0.02em;\n    color: #fefefe;\n    cursor: pointer;\n    z-index: 10;\n    transition: 0.2s;\n  }\n\n  img:hover + .image__hover {\n    display: flex;\n  }\n\n  .image__hover:hover {\n    display: flex;\n  }\n\n  input[type='file'] {\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"])), function (props) { return (props.isLoading ? '0.5' : '1'); });
var ImageCaption = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-top: 16px;\n\n  textarea {\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #151514;\n\n    &:focus {\n      opacity: 1;\n    }\n  }\n"], ["\n  margin-top: 16px;\n\n  textarea {\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #151514;\n\n    &:focus {\n      opacity: 1;\n    }\n  }\n"])));
var AttachmentsWrap = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var uploadValidator = function (_a) {
    var files = _a.files, toasts = _a.toasts, isWideImageType = _a.isWideImageType, profile = _a.profile, isComment = _a.isComment, style = _a.style, isLMS = _a.isLMS;
    return __awaiter(void 0, void 0, void 0, function () {
        var isModer, failedChecks, loadFile, MAX_MP3_FILE_SIZE, allowedAudioTypes, _b, height, width, ratio, MAX_GIF_FILE_SIZE, MAX_JPEG_FILE_SIZE, MAX_PNG_FILE_SIZE, failedSize, failedDimensions, failedRatio;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    isModer = bProfile.isModer(profile);
                    failedChecks = {};
                    loadFile = function () {
                        return new Promise(function (resolve, reject) {
                            var fr = new FileReader();
                            fr.onload = function () {
                                // file is loaded
                                var img = new Image();
                                img.onload = function () {
                                    var width = img.width, height = img.height;
                                    resolve({
                                        width: width,
                                        height: height
                                    });
                                };
                                // @ts-ignore
                                img.src = fr.result; // is the data URL because called with readAsDataURL
                            };
                            fr.readAsDataURL(files[0]);
                        });
                    };
                    if (style === 'podcast') {
                        MAX_MP3_FILE_SIZE = 157286400;
                        allowedAudioTypes = ['audio/mpeg', 'audio/wav', 'audio/x-wav', 'audio/wave'];
                        if (!allowedAudioTypes.includes((_c = files === null || files === void 0 ? void 0 : files[0]) === null || _c === void 0 ? void 0 : _c.type)) {
                            toasts.error('Загрузите mp3 файл');
                            return [2 /*return*/, false];
                        }
                        if (((_d = files === null || files === void 0 ? void 0 : files[0]) === null || _d === void 0 ? void 0 : _d.size) > MAX_MP3_FILE_SIZE) {
                            toasts.error('Максимальный размер mp3 - 150 МБ');
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, loadFile()];
                case 1:
                    _b = _o.sent(), height = _b.height, width = _b.width;
                    if ((height >= width && (height > 5262 || width > 3720)) ||
                        (width > height && (height > 3720 || width > 5262))) {
                        toasts.error('Максимальные размеры изображения - 3720х5262 и 5262x3720');
                        failedChecks.dimensions = true;
                    }
                    ratio = width / height;
                    if (isComment || isLMS) {
                    }
                    else if (isWideImageType) {
                        // const isSmallWideImage = ratio > 1.47 && ratio < 1.49
                        // const isLargeWideImage = ratio > 1.79 && ratio < 1.81
                        // if (!isSmallWideImage && !isLargeWideImage) {
                        //   toasts.error(
                        //     'Изображение неправильное (отношение ширины к высоте должно быть или 1.48, или 1.8)'
                        //   )
                        //   failedChecks.ratio = true
                        // }
                    }
                    else {
                        if (ratio < 0.6 && style !== 'two_pictures') {
                            toasts.error('Изображение слишком длинное (отношение ширины к высоте должно быть 0.6 и более)');
                            failedChecks.ratio = true;
                        }
                    }
                    MAX_GIF_FILE_SIZE = 20971520;
                    MAX_JPEG_FILE_SIZE = 157286400;
                    MAX_PNG_FILE_SIZE = 20971520;
                    if ((((_e = files === null || files === void 0 ? void 0 : files[0]) === null || _e === void 0 ? void 0 : _e.type) === 'image/jpeg' || ((_f = files === null || files === void 0 ? void 0 : files[0]) === null || _f === void 0 ? void 0 : _f.type) === 'image/jpg') &&
                        ((_g = files === null || files === void 0 ? void 0 : files[0]) === null || _g === void 0 ? void 0 : _g.size) > MAX_JPEG_FILE_SIZE) {
                        toasts.error('Максимальный размер jpeg-файла - 150Мб');
                        failedChecks.size = true;
                    }
                    if (((_h = files === null || files === void 0 ? void 0 : files[0]) === null || _h === void 0 ? void 0 : _h.type) === 'image/png' &&
                        ((_j = files === null || files === void 0 ? void 0 : files[0]) === null || _j === void 0 ? void 0 : _j.size) > MAX_PNG_FILE_SIZE) {
                        toasts.error('Максимальный размер png-файла - 20Мб');
                        failedChecks.size = true;
                    }
                    if (((_k = files === null || files === void 0 ? void 0 : files[0]) === null || _k === void 0 ? void 0 : _k.type) === 'image/gif' &&
                        ((_l = files === null || files === void 0 ? void 0 : files[0]) === null || _l === void 0 ? void 0 : _l.size) > MAX_GIF_FILE_SIZE) {
                        toasts.error('Максимальный размер gif-файла - 20Мб');
                        failedChecks.size = true;
                    }
                    if (!__spreadArray(['image/jpeg', 'image/jpg', 'image/gif', 'image/png'], (isModer ? ['image/png'] : []), true).includes((_m = files === null || files === void 0 ? void 0 : files[0]) === null || _m === void 0 ? void 0 : _m.type)) {
                        toasts.error('Допустимые форматы: jpg, png, gif');
                        failedChecks.size = true;
                    }
                    failedSize = failedChecks.size, failedDimensions = failedChecks.dimensions, failedRatio = failedChecks.ratio;
                    if (failedSize || failedDimensions || failedRatio) {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
            }
        });
    });
};
var UpdateEl = /** @class */ (function (_super) {
    __extends(UpdateEl, _super);
    function UpdateEl(props) {
        var _this = this;
        var _a, _b, _c, _d;
        _this = _super.call(this, props) || this;
        _this.handlePostButtonsChange = function (button) {
            _this.setState({ buttons: [button] });
        };
        _this.setBigImage = function () {
            if (_this.props.post.attachments.length > 0) {
                if (_this.props.post.style === 'image' ||
                    _this.props.post.style === 'big' ||
                    _this.props.post.style === 'as_cover') {
                    var bigImageSrc = _this.props.post.attachments[0].file &&
                        _this.props.post.attachments[0].file.url
                        ? "".concat(urlApi().getImageQueryLink()).concat(_this.props.post.attachments[0].file.url)
                        : '';
                    if (bigImageSrc) {
                        _this.setState({ bigImageSrc: bigImageSrc });
                    }
                }
            }
        };
        _this.handleClickOutside = function (event) {
            if (_this.wrapperRef &&
                !_this.wrapperRef.current.contains(event.target) &&
                _this.state.text.length > 0) {
                // this.props.toggleLongReadPostUpdate(0, false)
                /* вариант с сохранением поста */
                _this.updateLongReadPost();
            }
        };
        _this.updateLongReadLessonPost = function () {
            if (!_this.state.onLessonSave)
                return;
            _this.state.onLessonSave().then(function (r) { return _this.updateLongReadPost(false, r); });
        };
        _this.handleTitleBlock = function () {
            _this.setState({ style: 'block_with_title' });
        };
        _this.handleTextareaFocus = function (e) {
            var _a, _b, _c, _d;
            if (_this.state.secondaryStyle !== '') {
                return false;
            }
            var defaultTA = (_b = (_a = _this.textareaRef.current) === null || _a === void 0 ? void 0 : _a.firstChild) === null || _b === void 0 ? void 0 : _b.firstChild;
            defaultTA && defaultTA.focus();
            if (!_this.state.useRating) {
                var coloredTA = (_d = (_c = _this.coloredTextareaRef.current) === null || _c === void 0 ? void 0 : _c.firstChild) === null || _d === void 0 ? void 0 : _d.firstChild;
                coloredTA && coloredTA.focus();
            }
        };
        _this.onCaptionChange = function (e) {
            var height = e.target.offsetHeight;
            var htmlValue = e.target.value.substring(0, 800);
            var textLength = e.target.value;
            var linkProjectId = extractProjectId(htmlValue);
            _this.setState({
                caption: htmlValue,
            }, function () {
                if (textLength > 800) {
                    _this.props.toasts.error('Максимальная длина: 800 символов');
                }
            });
        };
        _this.onLinkResize = function (e) {
            _this.setState({
                text: e.target.value
            }, function () {
                if (_this.state.text.length > 200) {
                    _this.props.toasts.error('Максимальная длина: 200 символов');
                    _this.setState({
                        text: e.target.value.substring(0, 200),
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal',
                        linkText: _this.state.linkText
                    });
                }
            });
            if (_this.state.text.length > 200) {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal'
                    });
                });
            }
            setTimeout(function () { return _this.setSizes(); });
        };
        _this.handleSetLink = function (link) {
            var linkProjectId = extractProjectId(link);
            _this.setState({ linkText: link, linkProjectId: linkProjectId });
        };
        _this.onSourcesTextareaKeyUp = function (e) {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { text: modifyToListText(prevState.text, e) })); });
        };
        _this.replaceHiddenProjectLink = function (id, field) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = urlApi()) === null || _a === void 0 ? void 0 : _a.getProject({ id: id }).then(function (r) { return r.status === 200 && r.json(); }).then(function (project) {
                            var _a;
                            var _b, _c;
                            var isHiddenProject = project.status === 10;
                            if (isHiddenProject) {
                                _this.props.toasts.error('Нельзя добавить ссылку на скрытый проект');
                            }
                            _this.setState((_a = {},
                                _a[field] = isHiddenProject ? replaceAWithHref((_b = _this.state) === null || _b === void 0 ? void 0 : _b[field]) : (_c = _this.state) === null || _c === void 0 ? void 0 : _c[field],
                                _a.linkProjectId = '',
                                _a));
                        }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleResize = throttle(function () {
            _this.setSizes();
        }, 1000);
        _this.handleProjects = function () {
            var _a;
            var _b = _this.props, maxProjects = _b.maxProjects, teamContexts = _b.teamContexts, teamExtraFilter = _b.teamExtraFilter, isPresentation = _b.isPresentation, onOpenSetProjectsModal = _b.onOpenSetProjectsModal;
            onOpenSetProjectsModal({
                maxProjects: maxProjects,
                teamContexts: teamContexts,
                teamExtraFilter: teamExtraFilter,
                isPresentation: isPresentation,
                alreadyProjects: ((_a = _this.state) === null || _a === void 0 ? void 0 : _a.projectIds) || [],
                onSelectProjects: function (projectIds) {
                    _this.setState({
                        projectIds: projectIds || []
                    });
                }
            });
        };
        _this.handleUpdateWhitePostCard = function () {
            var _a;
            var filterAI = (_a = _this.state.additionalInfo) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; });
            _this.setState({
                cardId: '',
                additionalInfo: filterAI
            });
            var _b = _this.props, modal = _b.modal, lgid = _b.lgid, num = _b.num, getLongReadPosts = _b.getLongReadPosts, setEditLongRead = _b.setEditLongRead, bookId = _b.bookId;
            modal.show('cardSelect', {
                themeColor: _this.props.colorStyle,
                onCardSelect: function (cardId) {
                    modal.hide();
                    _this.setState({
                        additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify([{ cardId: cardId, isPay: false }]) }]),
                        bigImageSrc: '',
                        style: 'normal_card'
                    });
                }
            });
        };
        _this.handleProductsButton = function () {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, setEditLongRead = _a.setEditLongRead, bookId = _a.bookId, teamId = _a.teamId;
            modal.show('productsSelect', {
                cardIds: getCardIdsFromAdditionalInfo(_this.state.additionalInfo, _this.state.cardIds),
                teamId: teamId,
                onSubmit: function (cardIds) {
                    var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
                    var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
                    modal.hide();
                    _this.setState({
                        additionalInfo: additionalInfoUpdated,
                        cardIds: cardIdsUpdated,
                        style: 'products'
                    });
                }
            });
        };
        _this.handleButtonLink = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-link' ? '' : 'button-link'
            });
        };
        _this.handleWhitePostImageButton = function (ev) {
            var _a, _b;
            var style = (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b['type'];
            _this.setState({
                style: style,
            });
        };
        _this.handleAnchorButton = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-anchor' ? '' : 'button-anchor'
            });
        };
        _this.handleDeleteButton = function (id) {
            var confirm = window.confirm('Вы действительно хотите удалить кнопку?');
            var toasts = _this.props.toasts;
            if (confirm) {
                _this.setState({
                    // buttons: this.state.buttons?.filter((i) => i?.id !== id),
                    buttons: [],
                    secondaryStyle: '',
                }, function () {
                    toasts.info('Кнопка была удалена.');
                });
            }
        };
        _this.handleSetFormId = function (id) {
            _this.setState({
                formId: id,
            });
        };
        _this.handleAddForms = function () {
            _this.setState({
                style: 'forms'
            });
        };
        _this.handleAddLesson = function () {
            _this.setState({
                style: 'course_lesson'
            });
        };
        _this.handleAddPodcast = function () {
            _this.setState({
                style: 'podcast'
            });
        };
        _this.handleAddCoursePresentation = function () {
            _this.setState({
                style: 'course_presentation'
            });
        };
        _this.handleSetFormPosition = function (val) {
            _this.setState({
                formPosition: val,
            });
        };
        _this.handleCardButton = function (isImage) {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, toggleLongReadPostUpdate = _a.toggleLongReadPostUpdate, post = _a.post, bookId = _a.bookId, sign = _a.sign;
            if (_this.state.post.cardId)
                return;
            if (isImage) {
                urlApi().insertCardByImage({ postId: post.postId, longreadId: lgid }).then(function (res) {
                    setTimeout(function () {
                        getLongReadPosts('', lgid, sign);
                    }, 1000);
                    window.open(getGalllleryUrl() + '/card/' + (res === null || res === void 0 ? void 0 : res.cardId), '_blank');
                    // window.open(getGalllleryUrl() + '/collection/' + res?.collectionId + '?activeCard=' + res?.cardId, '_blank')
                });
                return;
            }
            modal.show('cardSelect', {
                onCardSelect: function (cardId) {
                    // toggleLongReadPostUpdate(0, false)
                    modal.hide();
                    _this.setState({
                        additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify([{ cardId: cardId, isPay: false }]) }]),
                        style: 'card'
                    });
                }
            });
        };
        _this.onChangeImage = function (event, index) { return __awaiter(_this, void 0, void 0, function () {
            var _a, toasts, profile, files, appName, allowed, _b;
            var _this = this;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, toasts = _a.toasts, profile = _a.profile;
                        files = (_c = Array.from(event.target.files)) === null || _c === void 0 ? void 0 : _c.slice(0, 1);
                        appName = getAppNameFromAppString(this.props.appName);
                        _b = ['geograffee', 'deziiign', 'competition'].includes(appName);
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadValidator({
                                files: files,
                                toasts: toasts,
                                profile: profile,
                                style: 'two_pictures',
                                isLMS: this.props.isLMS
                            })];
                    case 1:
                        _b = (_d.sent());
                        _d.label = 2;
                    case 2:
                        allowed = _b;
                        if (!allowed) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        this.uppy.reset();
                        files.forEach(function (file, i) {
                            var fr = new FileReader();
                            try {
                                _this.uppy.addFile({
                                    source: 'file input',
                                    name: file.name,
                                    type: file.type || 'application/octet-stream',
                                    data: file,
                                    meta: {
                                        contentType: file.type || 'application/octet-stream'
                                    }
                                });
                            }
                            catch (err) {
                                if (err.isRestriction) {
                                    // handle restrictions
                                    console.error('Restriction error:', err);
                                }
                                else {
                                    // handle other errors
                                    console.error(err);
                                }
                            }
                            fr.onload = function () {
                                var newImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                                newImg[index] = __assign(__assign({}, newImg[index]), { name: file.name, isUploaded: false, files: undefined, progress: 0, src: fr.result });
                                _this.setState({
                                    multiLoadGrouppedImg: newImg
                                });
                            };
                            fr.readAsDataURL(file);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleSortedProjects = function (projects) {
            _this.setState({
                projectIds: (projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return project === null || project === void 0 ? void 0 : project.id; })) || []
            });
        };
        _this.handleProductsChange = function (cardIds) {
            var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
            var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
            _this.setState({
                additionalInfo: additionalInfoUpdated,
                cardIds: cardIdsUpdated
            });
        };
        _this.handleSetCoursePresentation = function (projectId) {
            _this.setState({
                projectIds: [projectId]
            });
        };
        _this.handleDeleteProjects = function (deletedId) {
            var _a;
            var t = _this.props.t;
            if (!window.confirm(t('confirmation.project_block_item_delete')))
                return;
            _this.setState({
                projectIds: (_a = _this.state.projectIds) === null || _a === void 0 ? void 0 : _a.filter(function (id) { return id !== deletedId; })
            });
        };
        _this.handleImgRemove = function (id, name, needToConfirm) {
            var _a, _b, _c;
            var t = _this.props.t;
            if (needToConfirm) {
                if (!window.confirm(t('confirmation.image_delete')))
                    return;
            }
            var isEmpty = !((_b = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return ![i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); })) === null || _b === void 0 ? void 0 : _b.length);
            var isSpBlock = _this.state.style === 'super-puper-vote';
            var isSlider = _this.state.style === 'slider';
            // this.updateFileList(name)
            _this.setState({
                multiLoadGrouppedImg: (_c = _this.state.multiLoadGrouppedImg) === null || _c === void 0 ? void 0 : _c.filter(function (i) { return ![i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); }),
                spVoteError: isSpBlock
            });
            if (isEmpty && isSpBlock) {
                _this.setState({
                    multiLoadGrouppedImg: [],
                    multipleLoadSrc: [],
                    multipleLoadId: [],
                    spVoteError: false
                });
                _this.uppy.cancelAll();
                _this.uppy.reset();
            }
        };
        _this.handleTogglePostLikes = function (useRating) {
            return _this.setState({ useRating: useRating });
        };
        _this.handleToggleRatingDataChange = function (val, ev) {
            var _a;
            var _b;
            var target = ev.target;
            var value = val;
            var key = (_b = target === null || target === void 0 ? void 0 : target.dataset) === null || _b === void 0 ? void 0 : _b['key'];
            var data = _this.state.ratings;
            data = {
                custom: __assign(__assign(__assign({}, INITIAL_RAITING), data === null || data === void 0 ? void 0 : data.custom), (_a = {}, _a[key === 'name' ? 'name' : 'value'] = (key === 'name' ? value
                    : Number(value)), _a))
            };
            _this.setState({ ratings: data });
        };
        _this.handleSlideTextChange = function (id, text, textPosition) {
            var _a;
            var isPositionUpdate = text === 'updatePosition';
            var index = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.findIndex(function (i) { return [i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); });
            if (index === -1) {
                return;
            }
            var newArray = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
            newArray[index] = __assign(__assign(__assign({}, newArray[index]), (isPositionUpdate ? {} : { text: text })), { textPosition: textPosition });
            _this.setState({
                multiLoadGrouppedImg: newArray
            });
        };
        _this.handleTileViewTypeChange = function (type) {
            _this.setState({
                tileViewType: type
            });
        };
        _this.handleTextPositionChange = function (text, position) {
            if (position === 'caption' || position === 'caption-bottom') {
                _this.setState({
                    caption: text,
                    postTextPos: position,
                    text: ''
                });
            }
            else {
                _this.setState({
                    text: text,
                    postTextPos: position,
                    caption: '',
                });
            }
        };
        _this.handleSlideChecked = function (checked) {
            _this.setState({
                isRibbon: checked
            });
        };
        _this.handleSortedMultipleImgChange = function (list) {
            _this.setState({
                multiLoadGrouppedImg: __spreadArray([], list, true)
            });
        };
        _this.handleTogglePreviewer = function () {
            clearWidePreviewer();
        };
        _this.handleAddText = function (position) {
            var style = _this.state.style;
            var isSlider = style === 'slider';
            var isPresentation = (style === 'as_cover' || _this.props.post.style === 'as_cover') &&
                _this.props.isPresentation;
            if (!isSlider && !isPresentation) {
                _this.setState({
                    style: 'big',
                    postTextPos: position,
                    // caption: ''
                });
            }
            if (isPresentation) {
                _this.setState({
                    postTextPos: 'outside'
                });
            }
            if (isSlider) {
                _this.updatePostStatus('');
                _this.setState(function (_a) {
                    var editingText = _a.editingText, oldPosition = _a.position;
                    return ({
                        editingText: oldPosition === position ? editingText : !editingText,
                        editingCaption: false,
                        multiLoadCaptionMode: 'big',
                        postTextPos: position
                    });
                });
            }
        };
        _this.handleAnchorChange = function (text) {
            _this.setState({
                anchorText: text
            });
        };
        _this.setCaption = function (value) {
            _this.setState({ caption: value, postTextPos: 'caption-bottom', text: value, });
            _this.updatePostStatus(false);
        };
        _this.handleChangeAdditionalStyle = function () {
            _this.setState({ secondaryStyle: '' });
        };
        _this.updatePostStatus = function (style) {
            var _a = _this.props, toggleLongReadPostUpdate = _a.toggleLongReadPostUpdate, postId = _a.post.postId;
            toggleLongReadPostUpdate(postId, style);
        };
        var invertColor = function (bgColor, lightColor, darkColor) {
            var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
            var r = parseInt(color.substring(0, 2), 16); // hexToR
            var g = parseInt(color.substring(2, 4), 16); // hexToG
            var b = parseInt(color.substring(4, 6), 16); // hexToB
            return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
        };
        var defaultChooser = _this.props.post.style !== 'normal';
        var defaultText = _this.props.post.text;
        var defaultCaption = _this.props.post.attachments.length > 0
            ? _this.props.post.attachments[0].description
            : '';
        var defaultBgColor = ((_b = (_a = _this.props.post) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b[0]) === '#'
            ? _this.props.post.color
            : colorObj[_this.props.post.color];
        var defaultFontColor = ((_d = (_c = _this.props.post) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d[0]) === '#'
            ? invertColor(_this.props.post.color, 'white', '#151514')
            : colorObj.fonts[_this.props.post.color];
        // временно стайл, поскольку есть посты и со старыми стилями и с новыми
        var defaultStyle = function () {
            if (_this.props.post.style === '') {
                return 'normal';
            }
            if (_this.props.post.style === 'string') {
                if (_this.props.post.color === 'white' ||
                    _this.props.post.color === '#fff') {
                    return 'normal';
                }
                return 'colored';
            }
            return _this.props.post.style;
        };
        var multiLoadGrouppedImg = props.post.attachments.map(function (item) { return (__assign(__assign({}, item), { isUploaded: true })); });
        var getCaptionMode = function (p) { var _a, _b; return !!((_a = p.caption) === null || _a === void 0 ? void 0 : _a.length) ? 'small' : !!((_b = p === null || p === void 0 ? void 0 : p.text) === null || _b === void 0 ? void 0 : _b.length) ? 'big' : ''; };
        var getFormId = function (f) { var _a, _b, _c; return !!((_a = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) ? (_c = (_b = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (n) { return (n === null || n === void 0 ? void 0 : n.name) === 'formId'; })) === null || _c === void 0 ? void 0 : _c.value : ''; };
        var getFormPosition = function (f) { var _a, _b, _c; return !!((_a = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) ? (_c = (_b = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (n) { return (n === null || n === void 0 ? void 0 : n.name) === 'formPosition'; })) === null || _c === void 0 ? void 0 : _c.value : FORM_CENTER_POS; };
        _this.state = {
            post: _this.props.post,
            text: defaultText,
            anchorText: _this.props.post.anchorText,
            postTextPos: _this.props.post.titlePosition,
            projectIds: _this.props.post.projectIds || [],
            title: _this.props.post.title,
            addButtonsOpened: false,
            color: defaultBgColor,
            linkProjectId: '',
            fontColor: defaultFontColor,
            isColorChoose: defaultChooser,
            colorName: _this.props.post.color,
            isTitleOpened: defaultChooser,
            imageId: '',
            tileViewType: getTileViewType(_this.props.post),
            buttonUpdated: false,
            formId: getFormId(_this.props.post),
            formPosition: getFormPosition(_this.props.post),
            imageCaption: defaultCaption,
            multiLoadGrouppedImg: multiLoadGrouppedImg,
            multiLoadCaptionMode: getCaptionMode(_this.props.post),
            caption: _this.props.post.caption,
            prevImageSrc: '',
            audioSrc: '',
            bigImageSrc: '',
            style: _this.props.post.style,
            isTextTooBig: defaultText.length > 2400,
            prevColorStatus: 'white',
            isFirstLetter: _this.props.post.isFirstLetter,
            isLoading: false,
            isRibbon: _this.props.post.isRibbon,
            coloredPadding: 57,
            secondaryStyle: '',
            buttons: _this.props.post.buttons || [],
            lessonPostDisabled: true,
            cardIds: _this.props.post.cardIds,
            useRating: _this.props.post.useRating,
            ratings: _this.props.post.ratings,
            linkText: _this.props.post.linkText,
            additionalInfo: _this.props.post.additionalInfo,
            onLessonSave: function () { },
            disablePosting: false,
            isDropdownOpen: false,
        };
        _this.fileRef = createRef();
        _this.standartTA = createRef();
        _this.imageRef = createRef();
        _this.bigimageRef = createRef();
        _this.coloredTA = createRef();
        _this.wrapperRef = createRef();
        _this.captionRef = createRef();
        _this.textareaRef = createRef();
        _this.coloredTextareaRef = createRef();
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        // потом возможно в отдельную сущность вынести
        var isSlider = _this.props.post.style === 'slider';
        _this.uppy = new Uppy({
            restrictions: { maxNumberOfFiles: isSlider ? MAX_FILES_COUNT : 1 },
            meta: { type: 'image/jpeg' },
            autoProceed: true,
            onBeforeUpload: function (files) {
                var _a, _b;
                var isSlider = _this.state.style === 'slider';
                var isTile = _this.state.style === 'tile';
                var isTwoPictures = _this.state.style === 'two_pictures';
                var total = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length;
                var maxFiles = isTwoPictures ? 2 : isTile ? 9 : MAX_FILES_COUNT;
                var isMaxFilesCount = (isSlider || isTile || (isTwoPictures && !((_b = _this.state.multiLoadGrouppedImg) === null || _b === void 0 ? void 0 : _b.length))) && total > maxFiles;
                if (isMaxFilesCount) {
                    _this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E ".concat(isSlider ? 'cлайдов' : 'изображений', " - ").concat(maxFiles));
                    _this.setState({
                        multiLoadGrouppedImg: __spreadArray([], _this.state.multiLoadGrouppedImg, true).slice(0, maxFiles)
                    });
                }
                _this.setState({
                    isMultiLoad: isSlider || isTwoPictures || isTile,
                    isLoading: !(isSlider || isTwoPictures || isTile),
                });
            }
        })
            .use(Tus, {
            endpoint: "".concat(Endpoints.uploader, "/upload/"),
            chunkSize: 4194304
        })
            .use(FileInput, {
            target: _this.fileRef.current,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
            .use(FileInput, {
            target: _this.imageRef.current,
            id: 'imageRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
            .use(FileInput, {
            target: _this.bigimageRef.current,
            id: 'bigimage',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        });
        _this.uppy.on('file-added', function (file) {
            var isMultipleLoad = _this.state.style === 'slider' || _this.state.style === 'tile';
            /* Добавляем имя и дополнительные поля */
            if (isMultipleLoad) {
                var result = [];
                result.push.apply(result, __spreadArray(__spreadArray([], _this.state.multiLoadGrouppedImg, false), [{
                        name: file === null || file === void 0 ? void 0 : file.name,
                        isUploaded: false,
                        caption: '',
                        isCaptionSetted: false,
                        text: '',
                        isTextSetted: false,
                        progress: 0
                    }], false));
                _this.setState({
                    multiLoadGrouppedImg: result
                });
            }
        });
        _this.uppy.on('upload-progress', function (file, progress) {
            var _a;
            _this.setState({ disablePosting: true });
            if (_this.state.isMultiLoad) {
                var uppyState_1 = (_a = _this.uppy.getState()) === null || _a === void 0 ? void 0 : _a.files;
                setTimeout(function () {
                    var _loop_1 = function (key) {
                        var name_1 = uppyState_1[key].name;
                        var progress_1 = uppyState_1[key].progress.percentage;
                        /* Добавляем проценты прогресса */
                        // console.log(`PROGRESS FOR ${name} ->  ${progress}`)
                        var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                            var isUploaded = (i === null || i === void 0 ? void 0 : i.progress) === 100;
                            if (isUploaded) {
                                return i;
                            }
                            if ((i === null || i === void 0 ? void 0 : i.name) === name_1) {
                                return __assign(__assign({}, i), { progress: progress_1 });
                            }
                            return i;
                        });
                        _this.setState({
                            multiLoadGrouppedImg: result
                        });
                    };
                    for (var key in uppyState_1) {
                        _loop_1(key);
                    }
                }, 1500);
            }
        });
        _this.uppy.on('upload-success', function (file, response) {
            var _a;
            var isSuccess = ((_a = response === null || response === void 0 ? void 0 : response.uploadURL) === null || _a === void 0 ? void 0 : _a.length) > 1;
            setTimeout(function () {
                if (isSuccess) {
                    /* Добавляем поле об успешном добавлении */
                    var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                        if ((i === null || i === void 0 ? void 0 : i.name) === (file === null || file === void 0 ? void 0 : file.name)) {
                            return __assign(__assign({}, i), { isUploaded: true });
                        }
                        return i;
                    });
                    _this.setState({
                        multiLoadGrouppedImg: result
                    });
                }
            }, 1500);
        });
        _this.uppy.on('complete', function (result) {
            try {
                // то, что после загрузки картинки в уппи
                var fileData 
                // проверка есть ли файл
                = void 0;
                // проверка есть ли файл
                if (_this.props.post.attachments.length === 0) {
                    fileData = {
                        fileId: '',
                        containerId: 'string',
                        isNew: true,
                        type: 'string',
                        url: 'string',
                        size: 'string',
                        localization: 'string'
                    };
                }
                else {
                    fileData =
                        _this.props.post.attachments[0] &&
                            _this.props.post.attachments[0].file;
                }
                var url = result.successful[0].uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                var isSlider_1 = _this.state.style === 'slider' || _this.state.style === 'tile';
                var isPodcast = _this.state.style === 'podcast';
                var isTwoPictures = _this.state.style === 'two_pictures';
                if (isSlider_1) {
                    result.successful.forEach(function (item, idx) {
                        var url = item.uploadURL;
                        var linkT = url.split('/');
                        var lngh = linkT.length - 1;
                        var id = linkT[lngh];
                        var grouppedImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                        var imgIndex = grouppedImg.findIndex(function (i) {
                            return (i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name) && !(i === null || i === void 0 ? void 0 : i.isUploaded);
                        });
                        var newImg = [];
                        if (grouppedImg.find(function (i) { return (i === null || i === void 0 ? void 0 : i.id) === id; })) {
                            _this.props.toasts.error("\u0424\u0430\u0439\u043B \u0441 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C ".concat(item === null || item === void 0 ? void 0 : item.name, " \u0443\u0436\u0435 \u0431\u044B\u043B \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D"));
                            newImg = grouppedImg.filter(function (i, index) { return index !== imgIndex; });
                        }
                        else {
                            newImg = grouppedImg.map(function (i) {
                                if ((i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name)) {
                                    return __assign(__assign({}, i), { id: id });
                                }
                                return i;
                            });
                        }
                        _this.setState({
                            multiLoadGrouppedImg: newImg
                        });
                    });
                }
                else if (isTwoPictures) {
                    var newAttachments = _this.state.multiLoadGrouppedImg.reduce(function (acc, img) {
                        var uploaded = result.successful.find(function (_a) {
                            var name = _a.name;
                            return img.name === name;
                        });
                        if (!uploaded) {
                            return __spreadArray(__spreadArray([], acc, true), [img], false);
                        }
                        var url = uploaded.uploadURL;
                        var linkT = url.split('/');
                        var lngh = linkT.length - 1;
                        var id = linkT[lngh];
                        return __spreadArray(__spreadArray([], acc, true), [__assign(__assign({}, img), { file: {
                                    fileId: id, isNew: true
                                } })], false);
                    }, []);
                    _this.setState({
                        // imageId: id,
                        multiLoadGrouppedImg: newAttachments,
                        isLoading: false,
                        disablePosting: false
                    });
                }
                else {
                    var newAttach = __assign(__assign({}, _this.props.post.attachments[0]), { file: { fileData: fileData, fileId: id, isNew: true } });
                    var newAttachments = isPodcast ? [newAttach] : __spreadArray([newAttach], _this.props.post.attachments, true);
                    _this.setState({
                        imageId: id,
                        post: __assign(__assign({}, _this.props.post), { attachments: newAttachments }),
                        isLoading: false
                    });
                }
                _this.setState({ disablePosting: false });
            }
            catch (e) {
                console.error(e);
            }
        });
        _this.updateLongReadPost = _this.updateLongReadPost.bind(_this);
        _this.updateLongReadLessonPost = _this.updateLongReadLessonPost.bind(_this);
        _this.cancelUpdate = _this.cancelUpdate.bind(_this);
        _this.chooseColor = _this.chooseColor.bind(_this);
        _this.onColoredTextareaResize = _this.onColoredTextareaResize.bind(_this);
        _this.onStandartTextareaResize = _this.onStandartTextareaResize.bind(_this);
        _this.enableFirstLetter = _this.enableFirstLetter.bind(_this);
        _this.disableFirstLetter = _this.disableFirstLetter.bind(_this);
        _this.closeChooser = _this.closeChooser.bind(_this);
        _this.addText = _this.addText.bind(_this);
        _this.addFile = _this.addFile.bind(_this);
        _this.setBigImage = _this.setBigImage.bind(_this);
        _this.escFunction = _this.escFunction.bind(_this);
        _this.setDropdownOpen = _this.setDropdownOpen.bind(_this);
        return _this;
    }
    UpdateEl.prototype.setDropdownOpen = function (isOpen) {
        this.setState({ isDropdownOpen: isOpen });
    };
    UpdateEl.prototype.updateLongReadPost = function (isCardAbleToPurchase, customText) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var userid = localStorage.getItem('userId');
        var textLetter = this.state.isFirstLetter
            ? "".concat(this.state.text)
            : this.state.text;
        var slicedTextLetter = this.state.style === 'colored' ? textLetter.substring(0, 800) : textLetter;
        var isSlider = this.state.style === 'slider' || this.state.style === 'tile';
        var isTwoPictures = this.state.style === 'two_pictures';
        var isForm = this.state.style === 'forms';
        var finalStyle = ((_a = ['normal_image', 'normal_card']) === null || _a === void 0 ? void 0 : _a.includes(this.state.style)) ? 'normal' : this.state.style;
        // если добавили описание к картинки, добавляем
        var attachments = function () {
            if (_this.state.post.attachments.length === 0) {
                return [];
            }
            if (_this.state.style === 'normal_card') {
                return [];
            }
            if (isSlider) {
                return _this.state.multiLoadGrouppedImg.map(function (item) {
                    if (item === null || item === void 0 ? void 0 : item.files) {
                        return item;
                    }
                    return {
                        text: item === null || item === void 0 ? void 0 : item.text,
                        textPosition: item === null || item === void 0 ? void 0 : item.textPosition,
                        description: item === null || item === void 0 ? void 0 : item.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(item.id),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            // url: data?.src,
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    };
                });
            }
            if (isTwoPictures) {
                return _this.state.multiLoadGrouppedImg.map(function (item) {
                    if (item === null || item === void 0 ? void 0 : item.files) {
                        return item;
                    }
                    return {
                        text: item === null || item === void 0 ? void 0 : item.text,
                        textPosition: item === null || item === void 0 ? void 0 : item.textPosition,
                        description: item === null || item === void 0 ? void 0 : item.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: __assign({ fileId: "".concat(item.fileId), containerId: 'string', isNew: true, type: 'string', 
                            // url: data?.src,
                            url: 'string', size: 'string', localization: 'string' }, item.file)
                    };
                });
            }
            var newAttach = __spreadArray([], _this.state.post.attachments, true);
            newAttach[0].description = _this.state.imageCaption;
            return newAttach;
        };
        var autoCaption = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(this.state.style)) ? this.state.caption :
            (this.state.postTextPos !== 'caption-bottom' ? '' : (this.state.caption || slicedTextLetter));
        var autoText = this.state.style === 'podcast' ? this.state.post.text : (this.state.style === 'projects' || this.state.postTextPos === 'caption-bottom') ? '' : (slicedTextLetter || this.state.caption);
        var ratings = !!this.state.useRating ? this.state.ratings : {};
        var newAdditionalInfo = this.state.additionalInfo;
        if (isCardAbleToPurchase !== undefined) {
            newAdditionalInfo = addOrChangeAdditionalInfo(newAdditionalInfo, [
                { "name": CARDS_INFO_KEY, "value": updateIsPayInCardsInfo(newAdditionalInfo, isCardAbleToPurchase ? true : false) },
                { "name": "projectId", "value": (_c = this.props) === null || _c === void 0 ? void 0 : _c.projectId },
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
        }
        if (isForm)
            newAdditionalInfo = addOrChangeAdditionalInfo(newAdditionalInfo, [
                { "name": "formId", "value": this.state.formId },
                { "name": "formPosition", "value": this.state.formPosition },
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
        if (this.state.style === 'normal_image') {
            newAdditionalInfo = (_d = this.state.additionalInfo) === null || _d === void 0 ? void 0 : _d.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; });
        }
        if (this.state.style === 'tile') {
            newAdditionalInfo = addOrChangeAdditionalInfo(newAdditionalInfo, [
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
        }
        // формирование нового поста и отправка
        this.setState(__assign(__assign({}, (isForm ? { isLoading: true } : {})), { post: __assign(__assign({}, this.state.post), { additionalInfo: newAdditionalInfo, text: (customText || autoText), projectIds: this.state.projectIds, titlePosition: this.state.postTextPos, color: this.state.colorName, title: this.state.title, isFirstLetter: this.state.isFirstLetter, style: finalStyle, caption: autoCaption, loadAdditionalImage: isSlider || isTwoPictures, attachments: attachments(), anchorText: this.state.anchorText, buttons: this.state.buttons, cardIds: this.state.cardIds, useRating: this.state.useRating, ratings: ratings, isRibbon: this.state.isRibbon, linkText: this.state.linkText }) }), function () {
            _this.props.updateLongReadPost(_this.state.imageId, _this.state.post);
            _this.props.toggleLongReadPostUpdate(0, false);
        });
        var isEmblem = this.state.style;
        var timeout = ((_e = attachments()) === null || _e === void 0 ? void 0 : _e.length) && !isEmblem ? 5000 : 1000;
        setTimeout(function () {
            return _this.props.getLongReadPosts(userid, _this.props.lgid, _this.props.thematic);
        }, timeout);
        this.uppy.reset();
    };
    UpdateEl.prototype.enableFirstLetter = function () {
        var text = this.state.text;
        this.setState({
            isFirstLetter: true,
            firstLetter: text[0],
            text: this.state.text.substring(1)
        });
    };
    UpdateEl.prototype.disableFirstLetter = function () {
        this.setState({
            isFirstLetter: false,
            text: "".concat(this.state.text),
            firstLetter: ''
        });
    };
    UpdateEl.prototype.onImageRemove = function () {
        var _this = this;
        var _a;
        if ((_a = ['normal_image', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(this.state.style)) {
            this.setState({
                imageId: '',
                imageCaption: '',
                prevImageSrc: '',
                bigImageSrc: '',
                audioSrc: '',
                post: __assign(__assign({}, this.props.post), { attachments: [] })
            });
            this.uppy.reset();
            return;
        }
        var attachments = function () {
            var newAttach = __assign(__assign({}, _this.state.post.attachments[0]), { file: __assign(__assign({}, _this.state.post.attachments[0].file), { isDeleted: true }) });
            var newAttachments = __spreadArray([], _this.state.post.attachments, true);
            newAttachments.splice(0, 1, newAttach);
            return newAttachments;
        };
        this.setState({
            imageId: '',
            imageCaption: '',
            prevImageSrc: '',
            audioSrc: '',
            post: __assign(__assign({}, this.state.post), { attachments: attachments() })
        });
        this.uppy.reset();
    };
    UpdateEl.prototype.chooseColor = function (color, isUserColor, hex) {
        var calcStyle = this.state.style === "link" ? 'link' :
            this.state.style === 'annotation' ? 'annotation' : 'colored';
        if (isUserColor && this.state.style === "link") {
            if (hex && hex.startsWith('#')) {
                var projectId = this.props.projectId || this.props.lgid;
                var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                localStorage.setItem(storageKey, hex);
            }
            var invertColor = function (bgColor, lightColor, darkColor) {
                var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
                var r = parseInt(color.substring(0, 2), 16); // hexToR
                var g = parseInt(color.substring(2, 4), 16); // hexToG
                var b = parseInt(color.substring(4, 6), 16); // hexToB
                return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
            };
            this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(this.state.text),
                firstLetter: '',
                style: calcStyle,
                prevColorStatus: hex,
                linkText: this.state.linkText
            });
        }
        else if (isUserColor) {
            if (hex && hex.startsWith('#')) {
                var projectId = this.props.projectId || this.props.lgid;
                var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                localStorage.setItem(storageKey, hex);
            }
            var invertColor = function (bgColor, lightColor, darkColor) {
                var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
                var r = parseInt(color.substring(0, 2), 16); // hexToR
                var g = parseInt(color.substring(2, 4), 16); // hexToG
                var b = parseInt(color.substring(4, 6), 16); // hexToB
                return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
            };
            this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(this.state.text),
                firstLetter: '',
                style: calcStyle,
                prevColorStatus: hex
            });
        }
        else {
            this.setState({
                color: colorObj[color],
                isTitleOpened: true,
                fontColor: colorObj.fonts[color],
                colorName: color,
                isFirstLetter: false,
                text: "".concat(this.state.text),
                firstLetter: '',
                prevColorStatus: color,
                style: calcStyle
            });
        }
    };
    UpdateEl.prototype.onColoredTextareaResize = function (e) {
        var _this = this;
        var _a, _b, _c, _d;
        var height = e.target.offsetHeight;
        var htmlValue = e.target.value;
        var textLength = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length;
        var linkProjectId = extractProjectId(htmlValue);
        var maxLengthRules = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(this.state.style)) ? 75 : 800;
        var calcStyle = ((_c = ['annotation', 'block_with_title']) === null || _c === void 0 ? void 0 : _c.includes(this.state.style)) ?
            this.state.style : 'normal';
        var calcValue = ((_d = ['annotation', 'block_with_title']) === null || _d === void 0 ? void 0 : _d.includes(this.state.style)) ?
            htmlValue === null || htmlValue === void 0 ? void 0 : htmlValue.substring(0, maxLengthRules) : htmlValue;
        this.setState({
            text: e.target.value,
            linkProjectId: linkProjectId,
        });
        if (textLength > maxLengthRules) {
            this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043B\u0438\u043D\u0430: ".concat(maxLengthRules, " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"));
            setTimeout(function () {
                return _this.setState({
                    text: e.target.value.substring(0, 2400),
                    color: colorObj.white,
                    isTitleOpened: false,
                    fontColor: colorObj.fonts.white,
                    isTextTooBig: true,
                    isColorChoose: false,
                    prevColorStatus: _this.state.colorName,
                    colorName: 'white',
                    style: calcStyle
                });
            });
        }
        setTimeout(function () { return _this.setSizes(); });
    };
    UpdateEl.prototype.onSourcesTextareaChange = function (e) {
        var _this = this;
        onChangeBibliography(e, this.state.style, function (val) { return _this.props.toasts.error(val); }, function (val) { return _this.setState(val); });
    };
    UpdateEl.prototype.onStandartTextareaChange = function (e) {
        var linkProjectId = extractProjectId(e.target.value);
        if (e.target.value.length < 2400) {
            this.setState({
                text: e.target.value,
                linkProjectId: linkProjectId
            });
        }
        if (e.target.value.length >= 2400) {
            this.props.toasts.error('Максимальная длина: 2400 символов');
            this.setState({
                text: e.target.value.substring(0, 2400)
            });
        }
        if (this.state.text.length < 50) {
            this.setState({
                isFirstLetter: false,
                text: "".concat(e.target.value),
                firstLetter: ''
            });
        }
    };
    UpdateEl.prototype.onStandartTextareaResize = function (ev) {
        var _this = this;
        var height = ev.target.offsetHeight;
        var style = this.state.style;
        if (height > 150) {
            setTimeout(function () {
                return _this.setState({
                    color: colorObj.white,
                    isTitleOpened: false,
                    fontColor: colorObj.fonts.white,
                    isTextTooBig: true,
                    isColorChoose: false,
                    colorName: 'white',
                    style: style
                });
            });
        }
        if (height < 150) {
            if (this.state.prevColorStatus === 'white') {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: false,
                        isColorChoose: false,
                        colorName: 'white',
                        style: style
                    });
                });
            }
            else {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj[_this.state.prevColorStatus],
                        isTitleOpened: true,
                        fontColor: colorObj.fonts[_this.state.prevColorStatus],
                        isTextTooBig: false,
                        isColorChoose: true,
                        colorName: _this.state.prevColorStatus,
                        style: style
                    });
                });
            }
        }
    };
    UpdateEl.prototype.escFunction = function (event) {
        if (event.keyCode === 27) {
            // this.onBlueArea(event)
            this.props.toggleLongReadPostUpdate(0, false);
        }
    };
    UpdateEl.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('keydown', this.escFunction, false);
        document.addEventListener('mousedown', this.handleClickOutside);
        this.setBigImage();
    };
    UpdateEl.prototype.componentDidMount = function () {
        if (this.props.updateStatus === true &&
            this.state.style === 'image' &&
            (this.state.imageCaption !== '' || this.state.caption !== '')) {
            this.updatePostStatus('caption');
        }
        var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
        this.setState({ sliderControlsPlacer: sliderControlsPlacer });
    };
    UpdateEl.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = ['normal', 'colored']) === null || _a === void 0 ? void 0 : _a.includes(this.props.post.style)) &&
            !!((_b = this.state.buttons) === null || _b === void 0 ? void 0 : _b.length) && !this.state.buttonUpdated) {
            var type = ((_c = this.state.buttons) === null || _c === void 0 ? void 0 : _c[0]).type;
            this.setState({
                buttonUpdated: true,
                secondaryStyle: type === LINK_BUTTON_TYPE
                    ? BUTTON_TYPE['button-link']
                    : BUTTON_TYPE['button-anchor']
            });
        }
        if (((_d = [
            'colored',
            'normal_image',
            'normal',
            'normal_card',
            'normal_emblem'
        ]) === null || _d === void 0 ? void 0 : _d.includes(this.state.style)) &&
            !!((_e = this.state.linkProjectId) === null || _e === void 0 ? void 0 : _e.length)) {
            var field = ((_f = [
                'colored',
                'normal_image',
                'normal',
                'normal_card',
                'normal_emblem'
            ]) === null || _f === void 0 ? void 0 : _f.includes(this.state.style)) ? 'text' : 'linkText';
            this.replaceHiddenProjectLink(this.state.linkProjectId, field);
        }
    };
    UpdateEl.prototype.componentDidMount = function () {
        var _a, _b, _c;
        if (this.props.post.style === 'normal') {
            var type = !!((_a = this.props.post.attachments) === null || _a === void 0 ? void 0 : _a.length) ? 'normal_image' :
                !!((_b = getCardIdsFromAdditionalInfo(this.state.additionalInfo)) === null || _b === void 0 ? void 0 : _b.length) ? 'normal_card' : 'normal';
            this.setState(__assign({ style: type }, (((_c = ['normal_card', 'normal_image']) === null || _c === void 0 ? void 0 : _c.includes(type)) && { text: this.props.post.text })));
        }
    };
    UpdateEl.prototype.componentWillUnmount = function () {
        this.uppy.close();
        this.props.toggleMobileEditor && this.props.toggleMobileEditor(false);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('keydown', this.escFunction, false);
    };
    UpdateEl.prototype.setSizes = function () {
        var innerWidth = window.innerWidth;
        // отступ цветного блока
        if (this.coloredTA.current !== null) {
            var textHeight = this.coloredTA.current.offsetHeight;
            this.setPaddings(textHeight, innerWidth);
        }
    };
    UpdateEl.prototype.setPaddings = function (textHeight, innerWidth) {
        var paddingsCurrent, heightsCurrent, calculatedHeightStyle;
        // проверяем ширину экрана
        if (innerWidth > MEDIA_QUERY) {
            paddingsCurrent = paddings.max;
            heightsCurrent = heights.max;
        }
        else {
            paddingsCurrent = paddings.min;
            heightsCurrent = heights.min;
        }
        // выставляем нужный паддинг
        calculatedHeightStyle = Math.round(textHeight / heightsCurrent);
        if (calculatedHeightStyle >= 4) {
            calculatedHeightStyle = 4;
        }
        this.setState({
            coloredPadding: paddingsCurrent[calculatedHeightStyle]
        });
    };
    UpdateEl.prototype.addFile = function (event, style) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, toasts, profile, isCover, isPodcast, files, appName, allowed, _c, fr_1;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = this.props, toasts = _b.toasts, profile = _b.profile;
                        isCover = style === 'as_cover';
                        isPodcast = style === 'podcast';
                        files = isPodcast ? (_a = Array.from(event.target.files)) === null || _a === void 0 ? void 0 : _a.slice(0, 1) : Array.from(event.target.files);
                        appName = getAppNameFromAppString(this.props.appName);
                        _c = ['geograffee', 'deziiign', 'competition'].includes(appName);
                        if (!_c) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadValidator({
                                files: files,
                                toasts: toasts,
                                isWideImageType: isCover,
                                profile: profile,
                                style: style,
                                isLMS: this.props.isLMS
                            })];
                    case 1:
                        _c = (_d.sent());
                        _d.label = 2;
                    case 2:
                        allowed = _c;
                        if (!allowed) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        if (style !== 'slider' && style !== 'two_pictures' && style !== 'tile') {
                            fr_1 = new FileReader();
                            this.uppy.reset();
                            files.forEach(function (file) {
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr_1.onload = function () {
                                    var _a, _b;
                                    if (style === 'small') {
                                        _this.setState({
                                            prevImageSrc: fr_1.result
                                        });
                                    }
                                    if (isPodcast) {
                                        _this.setState({
                                            text: ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.name) || '',
                                            audioSrc: fr_1.result,
                                            post: __assign(__assign({}, _this.state.post), { text: ((_b = files[0]) === null || _b === void 0 ? void 0 : _b.name) || '' })
                                        });
                                    }
                                    if (['big', 'image', 'as_cover', 'normal_image', 'normal_emblem'].includes(style)) {
                                        _this.setState({
                                            bigImageSrc: fr_1.result,
                                            style: style,
                                            isColorChoose: true,
                                            color: '#00000000'
                                        });
                                    }
                                };
                                fr_1.readAsDataURL(files[0]);
                            });
                        }
                        if (style === 'slider' || style === 'two_pictures' || style === 'tile') {
                            this.uppy.reset();
                            files.forEach(function (file, i) {
                                var fr = new FileReader();
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr.onload = function () {
                                    var _a;
                                    var newImg = (_a = __spreadArray([], _this.state.multiLoadGrouppedImg, true)) === null || _a === void 0 ? void 0 : _a.map(function (img) {
                                        if ((img === null || img === void 0 ? void 0 : img.name) === (file === null || file === void 0 ? void 0 : file.name) && !(img === null || img === void 0 ? void 0 : img.files)) {
                                            return __assign(__assign({}, img), { src: fr.result });
                                        }
                                        return img;
                                    });
                                    _this.setState({
                                        multiLoadGrouppedImg: newImg
                                    });
                                };
                                fr.readAsDataURL(file);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UpdateEl.prototype.closeChooser = function () {
        this.setState({
            isColorChoose: false,
            isTitleOpened: false,
            color: colorObj.white,
            fontColor: colorObj.fonts.white,
            // color: colorObj['white'],
            colorName: 'white',
            style: 'normal',
            prevColorStatus: 'white'
        });
    };
    UpdateEl.prototype.onFocusArea = function (e) {
        e.target.setSelectionRange(e.target.value.length, e.target.value.length);
    };
    UpdateEl.prototype.addText = function (e) {
        var _this = this;
        if (e.target.value.length < 300) {
            this.setState({
                text: e.target.value
            });
        }
        if (e.target.value.length >= 300) {
            this.setState({
                text: e.target.value.substring(0, 298)
            }, function () {
                if (_this.state.text.length >= 300) {
                    _this.setState({
                        text: e.target.value.substring(0, 298)
                    });
                }
            });
        }
    };
    UpdateEl.prototype.cancelUpdate = function () {
        this.props.toggleLongReadPostUpdate(0, false);
    };
    UpdateEl.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        var _3 = this.state, style = _3.style, postTextPos = _3.postTextPos;
        var isSlider = style === 'slider' || style === 'tile';
        var isTwoPictures = style === 'two_pictures';
        var isProjects = style === 'projects';
        var isMultiLoadDisabled = (_a = this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.every(function (img) { return img.isUploaded; });
        var canSaveWPimage = !(this.state.style === 'normal_image' && (!((_c = (_b = this.state.post) === null || _b === void 0 ? void 0 : _b.attachments) === null || _c === void 0 ? void 0 : _c.length) || this.state.text.length === 0));
        var canSaveWPcard = !(this.state.style === 'normal_card' && (((_f = (_e = (!((_d = this.state.additionalInfo) === null || _d === void 0 ? void 0 : _d.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })))) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.length) || ((_g = this.state.text) === null || _g === void 0 ? void 0 : _g.length) === 0));
        var isDisabled = this.state.disablePosting || (this.state.style === 'podcast' ? ((_h = this.state.post.text) === null || _h === void 0 ? void 0 : _h.length) === 0 : this.state.style === 'course_lesson'
            ? this.state.lessonPostDisabled
            : (this.state.style === 'projects' || this.state.style === 'course_presentation')
                ? ((_j = this.state.projectIds) === null || _j === void 0 ? void 0 : _j.length) === 0
                : (this.state.style === 'products' || this.state.style === 'card')
                    ? !((_k = getCardIdsFromAdditionalInfo(this.state.additionalInfo)) === null || _k === void 0 ? void 0 : _k.length)
                    : isSlider
                        ? (((_l = this.state.multiLoadGrouppedImg) === null || _l === void 0 ? void 0 : _l.length) < 2 || ((_m = this.state.multiLoadGrouppedImg) === null || _m === void 0 ? void 0 : _m.length) > MAX_FILES_COUNT)
                        : isTwoPictures
                            ? ((((_o = this.state.multiLoadGrouppedImg) === null || _o === void 0 ? void 0 : _o.length) !== 2) || !isMultiLoadDisabled)
                            : (!canSaveWPcard || !canSaveWPimage) ? true
                                : (this.state.style === 'forms') ? false
                                    : !!((this.state.text.length === 0 &&
                                        this.props.post.attachments.length === 0) ||
                                        this.state.isLoading));
        var _4 = this.props, colorStyle = _4.colorStyle, _5 = _4.post, postId = _5.postId, userId = _5.userId, longreadId = _5.longreadId, t = _4.t;
        var caption = this.state.caption;
        var captionColorStyle = 'light';
        var additionalStyle = this.state.secondaryStyle;
        var attachment = this.props.post.attachments.length && this.props.post.attachments[0] ? this.props.post.attachments[0] : null;
        var titlePosition = this.state.postTextPos || 'inside';
        var showVotesCollection = !!((_p = this.props.votesContent) === null || _p === void 0 ? void 0 : _p.isCollectionVote);
        var buttons = ((_q = this.props.post) === null || _q === void 0 ? void 0 : _q.buttons) || [];
        var bigImageUrl = "";
        if (attachment) {
            var file = attachment.file ? attachment.file : attachment.files[0];
            if (file)
                bigImageUrl = "".concat(urlApi().getImageQueryLink()).concat(file.url);
        }
        var isImage = ['image', 'big', 'as_cover'].includes(style);
        var isLMS = this.props.isLMS;
        var isRibbon = this.state.isRibbon;
        var isPresentation = (style === 'as_cover' || this.props.post.style === 'as_cover') && this.props.isPresentation;
        var updatePortal = !!((_r = (this.state.bigImageSrc || bigImageUrl)) === null || _r === void 0 ? void 0 : _r.length);
        var ratingEditorVisible = !!this.state.useRating;
        var isFirstCover = this.state.style === 'as_cover' && !isPresentation;
        var isSpVote = this.state.style === 'super-puper-vote';
        var editingCaption = this.props.updateStatus === 'caption' &&
            ['image', 'slider', 'projects', 'two_pictures', 'tile'].includes(style);
        var isImageCaptionSetted = this.state.style === 'image' && this.state.imageCaption !== '';
        var isBigImageTextSetted = this.state.style === 'big' && this.state.text !== '';
        var isForPay = getIsPayFromPost(this.state);
        var currentActiveCaption = (isImageCaptionSetted || (isSlider && this.state.multiLoadCaptionMode === 'small')) ? 'small-caption' : (isBigImageTextSetted || (isSlider && this.state.multiLoadCaptionMode === 'big')) ? 'big-caption' : null;
        var hideBackground = isPresentation; /*&& (this.state.postTextPos === 'outside' || !!this.props.editorComponent)*/
        var toasts = this.props.toasts;
        var appName = getAppNameFromAppString(this.props.appName);
        var isGallllery = ['gallllery'].includes(appName);
        // console.log(`FIX WIDTH: ${this.props.isPresentation || isSlider}`)
        // console.log('pooplist2', this.state.multiLoadGrouppedImg);
        var isBottom = !isImage && !isFirstCover && !isSpVote && !isSlider && !isPresentation && !isProjects && !isTwoPictures;
        var isTop = (isImage && !isFirstCover) || isSlider || isPresentation || isProjects || isTwoPictures;
        var textValue = !((_s = this.state.text) === null || _s === void 0 ? void 0 : _s.length) ? this.state.caption : !((_t = this.state.caption) === null || _t === void 0 ? void 0 : _t.length) ? this.state.text : this.state.text;
        var cardIds = getCardIdsFromAdditionalInfo(this.state.additionalInfo);
        var editorToolbar = (React.createElement(EditorToolbar, { typeConnection: this.props.typeConnection, position: isBottom ? 'bottom' : isTop ? 'top' : 'none', style: style, bookId: this.props.bookId, isForPay: isForPay, cardId: (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 ? cardIds[0] : this.props.post.cardId, includedCards: this.props.includedCards, editing: true, variant: 'update', editingCaption: editingCaption, onAdditionalStyleDelete: this.handleChangeAdditionalStyle, onClose: function () { return _this.props.toggleLongReadPostUpdate(0, false); }, isPresentation: isPresentation, postTextPos: this.state.postTextPos, hasImage: isImage, postWithRaiting: this.state.useRating, multiLoadCaptionMode: this.state.multiLoadCaptionMode, colorPickerComponent: React.createElement(React.Fragment, null, (style === 'colored' || style === "link" || style === 'annotation') && (React.createElement(ColorMenuComp, { color: this.state.color, closeChooser: this.closeChooser, chooseColor: this.chooseColor, bigimageRef: this.bigimageRef, addFile: this.addFile, clickedAction: this.updateLongReadPost, isDisabled: isDisabled, style: 'update', canceledAction: this.cancelUpdate, postStyle: this.state.style, src: this.state.bigImageSrc }))), onAddImage: this.addFile, onAddForms: this.handleAddForms, onAddCard: this.handleCardButton, onAddLesson: this.handleAddLesson, onAddPodcast: this.handleAddPodcast, onAddProduct: this.handleProductsButton, onAddCoursePresentation: this.handleAddCoursePresentation, onButtonsDelete: this.handleDeleteButton, onAddProjects: this.handleProjects, onTogglePostLikes: this.handleTogglePostLikes, fileRef: this.fileRef, onSubmit: style === 'course_lesson' ? this.updateLongReadLessonPost : this.updateLongReadPost, postDisabled: isDisabled, onAddButtonLink: this.handleButtonLink, onAddAnchorButton: this.handleAnchorButton, additionalStyle: additionalStyle, onAddTitlePost: this.handleTitleBlock, onAddCaption: function (position) {
                _this.updatePostStatus('caption');
                if (!isSlider && !isPresentation && !isProjects) {
                    _this.setState({ style: 'image', postTextPos: 'caption-bottom' });
                }
                if (isPresentation) {
                    _this.setState({
                        postTextPos: position
                    });
                }
                if (isSlider) {
                    _this.setState({
                        multiLoadCaptionMode: 'small'
                    });
                }
            }, onAddText: this.handleAddText, onAddWhitePost: function () { return _this.setState({ style: 'normal' }); }, onAddWhitePostImages: this.handleWhitePostImageButton, onAddColoredPost: function () {
                var hex = _this.state.color || '#2A3034';
                _this.setState({
                    style: 'colored',
                    color: _this.state.color || '#2A3034',
                    colorName: 'black',
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                });
            }, onAddLinkPost: function () {
                var hex = _this.state.color || '#2A3034';
                _this.setState({
                    style: 'link',
                    color: _this.state.color || '#2A3034',
                    colorName: 'black',
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                    text: "".concat(_this.state.text),
                    linkText: _this.state.linkText
                });
            }, anchorText: this.state.anchorText, onAnchorChange: this.handleAnchorChange, onAddSlider: function () { }, onAddVideo: function () { return _this.setState({ style: 'video' }); }, onAddAudio: function () { return _this.setState({ style: 'audio' }); }, onAddImageSources: function () { return _this.setState({ style: 'image_sources' }); }, onAddBibliography: function () { return _this.setState({ style: 'bibliography' }); }, appName: this.props.appName, additionalInfo: this.state.additionalInfo, onToggleWidePreviewer: this.handleTogglePreviewer, setAdditionalInfo: function (additionalInfo) {
                _this.setState({ additionalInfo: additionalInfo });
            }, currentActiveCaption: currentActiveCaption, setSliderControlsPlacer: function () {
                var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
                _this.setState({ sliderControlsPlacer: sliderControlsPlacer });
            }, isDropdownOpen: this.state.isDropdownOpen }));
        return (React.createElement(React.Fragment, null,
            (this.state.style === "image_sources" || this.state.style === "bibliography") && React.createElement(FlexBox, { width: '100%', justify: "center" },
                React.createElement(UpdateHeaderToggle, { colorStyle: colorStyle, viewType: this.props.viewType }, t('editor.' + this.state.style))),
            React.createElement(Wrap, { isGalllleryNewStyle: isGallllery, updateStatus: this.props.updateStatus, ref: this.wrapperRef, withHeader: this.state.style === "image_sources" || this.state.style === "bibliography", index: this.props.index, hideBackground: hideBackground, fixWidth: this.props.isPresentation || isSlider || isLMS, blocksLength: this.props.blocksLength, zIndex: this.props.isDragging
                    ? 800
                    : Math.max(1, this.props.blocksLength + 3 - this.props.index) },
                isTop && editorToolbar,
                editingCaption && (React.createElement(CaptionEdit, { value: textValue, onSubmit: function (value) { return _this.setCaption(value); }, onCancel: function () { return _this.updatePostStatus(false); } })),
                this.state.style === 'big' || this.state.style === 'image' ? (React.createElement(React.Fragment, null,
                    additionalStyle !== '' && (React.createElement(ButtonBlock, { data: buttons, uprise: UPRISE_TYPE.dropdown, type: additionalStyle, onAddNewButton: this.handlePostButtonsChange, isEdited: true, setDropdownOpen: this.setDropdownOpen })),
                    React.createElement(BigImageComp, { userId: (_u = this.props.post) === null || _u === void 0 ? void 0 : _u.userId, isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc || bigImageUrl, TAvalue: textValue, TAOnChange: this.addText, style: this.state.style, postId: (_v = this.props.post) === null || _v === void 0 ? void 0 : _v.postId, cardId: (_w = this.props.post) === null || _w === void 0 ? void 0 : _w.cardId, textPosition: postTextPos }))) : style === 'card' ? (React.createElement(BigImageCard, { userId: (_x = this.props.post) === null || _x === void 0 ? void 0 : _x.userId, isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc || bigImageUrl, TAvalue: textValue, TAOnChange: this.addText, style: this.state.style, postId: (_y = this.props.post) === null || _y === void 0 ? void 0 : _y.postId, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo), textPosition: postTextPos })) : ((_z = ['annotation', 'block_with_title']) === null || _z === void 0 ? void 0 : _z.includes(this.state.style)) ? (React.createElement(BlockWithTitleEdit, { ref: this.coloredTextareaRef, onChange: function (e) { return _this.onColoredTextareaResize(e); }, onCaptionChange: function (e) { return _this.onCaptionChange(e); }, 
                    // onFocus={(e) => this.onFocusArea(e)}
                    text: this.state.text, style: this.state.style, caption: this.state.caption, bgcolor: this.state.color, fontColor: this.state.fontColor })) : this.state.style === 'colored' ? (React.createElement(EditTitle, { bgcolor: this.state.color, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, viewType: this.props.viewType },
                    React.createElement("div", { ref: this.coloredTextareaRef },
                        React.createElement(TextArea, { value: this.state.text.substring(0, 2400), onChange: function (e) { return _this.onColoredTextareaResize(e); }, placeholder: t('editor.inputs.placeholder'), 
                            // onResize={this.onColoredTextareaResize}
                            ref: this.coloredTA, postType: this.state.style, onFocus: function (e) { return _this.onFocusArea(e); }, autoFocus: true }),
                        additionalStyle !== '' && (React.createElement(ButtonBlock, { data: buttons, uprise: UPRISE_TYPE.colored, type: additionalStyle, onAddNewButton: this.handlePostButtonsChange, isEdited: true, setDropdownOpen: this.setDropdownOpen }))),
                    ratingEditorVisible && (React.createElement(RaitingBox, { onChange: this.handleToggleRatingDataChange, data: this.state.ratings })))) : this.state.style === 'link' ? (React.createElement(EditTitle, { bgcolor: this.state.color, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, viewType: this.props.viewType, isLinkBlock: true },
                    React.createElement("div", { ref: this.coloredTextareaRef },
                        React.createElement(LinkArea, { value: this.state.text, onChange: function (e) { return _this.onLinkResize(e); }, linkText: this.state.linkText, onLinkChange: function (linkText) { return _this.handleSetLink(linkText); }, placeholder: t('editor.inputs.link_placeholder'), ref: this.coloredTA, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, fontColor: this.state.fontColor, bgcolor: this.state.color, autoFocus: true, resize: false }),
                        additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.colored, onAddNewButton: this.handlePostButtonsChange, setDropdownOpen: this.setDropdownOpen }))))) : (this.state.style === "image_sources" || this.state.style === "bibliography") ? (React.createElement("div", null,
                    React.createElement(EditorWrap, { onClick: this.handleTextareaFocus },
                        React.createElement(TextWrapper, null,
                            React.createElement(LeftColumn, { isBiblio: true },
                                React.createElement(FlexBox, { direction: "column", directionMobile: "column", offsetLeft: 36, gy: 16 },
                                    (!this.props.alreadyHasBibliography || this.state.style === 'bibliography') && React.createElement(RadioButton, { checked: this.state.style === 'bibliography', onChange: function () {
                                            _this.setState({ style: 'bibliography' });
                                        }, name: 'bibliography' },
                                        React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.bibliography'))),
                                    (!this.props.alreadyHasImageSources || this.state.style === 'image_sources') && React.createElement(RadioButton, { checked: this.state.style === 'image_sources', onChange: function () {
                                            _this.setState({ style: 'image_sources' });
                                        }, name: 'image_sources' },
                                        React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.image_sources'))))),
                            React.createElement(RightColumn, null,
                                React.createElement("div", { ref: this.textareaRef },
                                    React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onSourcesTextareaChange(e); }, onKeyUp: function (e) { return _this.onSourcesTextareaKeyUp(e); }, placeholder: t('editor.inputs.placeholder'), onResize: this.onSourcesTextareaChange, maxLength: this.state.style === 'image_sources' ? 100000 : 50000, onFocus: function (e) { return _this.onFocusArea(e); }, type: TEXTAREA_TYPE.bibliography, autoFocus: true }))))))) : this.state.style === 'as_cover' ? (React.createElement(React.Fragment, null, isPresentation ? (React.createElement(PresentationBlock, { theme: this.props.theme, blocksLength: this.props.blocksLength, colorStyle: colorStyle, src: this.state.bigImageSrc || bigImageUrl, fileRef: this.fileRef, onAddImage: this.addFile, TAvalue: this.state.text, TAOnChange: this.addText, postDisabled: isDisabled, isEditingCaption: editingCaption, postTextPos: titlePosition, updatePortal: updatePortal, onPresentationHeaderChange: (_0 = this.props) === null || _0 === void 0 ? void 0 : _0.onPresentationHeaderChange, editorComponent: this.props.editorComponent, onSubmit: this.updateLongReadPost, isUpdate: true })) : (React.createElement(FirstAsCoverBlock, { src: this.state.bigImageSrc || bigImageUrl, onAddImage: this.addFile, fileRef: this.fileRef, onSubmit: this.updateLongReadPost, postDisabled: isDisabled })))) : this.state.style === 'super-puper-vote' ? (React.createElement(React.Fragment, null, showVotesCollection ? (React.createElement(Votepostwithcollect, { post: this.props.post, toggleLongReadPostUpdate: toggleLongReadPostUpdate, imgRef: this.imageRef, isUpdatePost: true, votesContent: this.props.votesContent, 
                    // dragHandleProps={dragHandleProps}
                    // isDragging={isDragging}
                    // isDragContinue={isDragContinue}
                    // isEditable={isEditable}
                    // linkTo={linkTo}
                    // colorStyle={colorStyle}
                    viewType: this.props.viewType })) : (React.createElement(VotePostBlock, { post: this.props.post, toggleLongReadPostUpdate: toggleLongReadPostUpdate, imgRef: this.imageRef, isUpdatePost: true, votesContent: this.props.votesContent, 
                    // dragHandleProps={dragHandleProps}
                    // isDragging={isDragging}
                    // isDragContinue={isDragContinue}
                    // isEditable={isEditable}
                    // linkTo={linkTo}
                    // colorStyle={colorStyle}
                    viewType: this.props.viewType })))) : style === 'two_pictures' ? (React.createElement(TwoPicturesBlock, { isLoading: !isMultiLoadDisabled, srcList: this.state.multiLoadGrouppedImg, onSlideTextChange: this.handleSlideTextChange, onChange: this.handleSortedMultipleImgChange, onChangeImage: this.onChangeImage, textPosition: this.state.postTextPos, controlsPlacer: this.state.sliderControlsPlacer, caption: textValue, fileRef: this.imageRef, onCaptionEdit: function () {
                        _this.updatePostStatus('caption');
                        _this.setState({
                            postTextPos: 'caption-bottom'
                        });
                    }, isEditable: true })) : (this.state.style === 'slider' || this.state.style === 'tile') ? (React.createElement(SliderEditBlock, { srcList: this.state.multiLoadGrouppedImg, isUpdatePost: true, style: style, viewType: this.props.viewType, TAvalue: textValue, TAOnChange: this.handleTextPositionChange, onImgRemove: this.handleImgRemove, handleSlideChecked: this.handleSlideChecked, onTileViewTypeChange: this.handleTileViewTypeChange, isRibbon: isRibbon, onSlideTextChange: this.handleSlideTextChange, onSetSortedImg: this.handleSortedMultipleImgChange, editingText: this.state.editingText, captionMode: this.state.multiLoadCaptionMode, textPosition: this.state.postTextPos, controlsPlacer: this.state.sliderControlsPlacer, caption: textValue, tileViewType: this.state.tileViewType })) : style === 'projects' ? (React.createElement(ProjectEditBlock, { style: style, projectIds: this.state.projectIds, onSetSortedProject: this.handleSortedProjects, onDeleteProject: this.handleDeleteProjects })) : style === 'products' ? (React.createElement(ProductsBlock, { style: style, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo), onChange: this.handleProductsChange, onSetSortedProject: this.handleSortedProjects, onDeleteProject: this.handleDeleteProjects, isEditable: true })) : style === 'course_presentation' ? (React.createElement(CoursePresentationEditBlock, { style: style, onSelect: this.handleSetCoursePresentation, selectedProject: this.state.projectIds })) : this.state.style === 'forms' ? (React.createElement(FormsBlock, { post: this.props.post, isUpdatePost: true, isDisabled: true, colorStyle: colorStyle, isLoading: this.state.isLoading, onSetFormPosition: this.handleSetFormPosition, onFormIdSet: this.handleSetFormId })) : this.state.style === 'course_lesson' ? (React.createElement(LessonEditBlock, { post: this.props.post, lessonId: this.state.text, isLoading: this.state.isLoading, onSubmit: function (text) { return _this.setState({ text: text }); }, setLessonPostDisabled: function (lessonPostDisabled) { return _this.setState({ lessonPostDisabled: lessonPostDisabled }); }, setOnLessonSave: function (onLessonSave) { return _this.setState({ onLessonSave: onLessonSave }); } })) : this.state.style === 'podcast' ? (React.createElement(PodcastEditBlock, { podcastTimecodes: JSON.parse(getAdditionalInfoVal(this.state.additionalInfo, 'podcastTimeCodes') || "[]"), isLoading: this.state.isLoading, audioSrc: this.state.post.audioSrc, podcastName: this.state.post.text, isNewPost: !this.state.post.postId, onClearPodcastFile: function () {
                        _this.setState({
                            post: __assign(__assign({}, _this.state.post), { text: '', audioSrc: '' })
                        });
                        if (_this.fileRef.current)
                            _this.fileRef.current.value = '';
                    }, onSetPodcastTimeCodes: function (podcastTimeCodes) {
                        _this.setState({
                            post: __assign(__assign({}, _this.state.post), { additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTimeCodes", "value": JSON.stringify(podcastTimeCodes) }]) }),
                            additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTimeCodes", "value": JSON.stringify(podcastTimeCodes) }])
                        });
                    }, onSetPodcastTotalTime: function (podcastTime) {
                        _this.setState({
                            post: __assign(__assign({}, _this.state.post), { additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTime", "value": String(podcastTime) }]) }),
                            additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTime", "value": String(podcastTime) }])
                        });
                    }, fileRef: this.fileRef, onAddImage: this.addFile })) : (React.createElement("div", null,
                    React.createElement(EditorWrap, { onClick: this.handleTextareaFocus },
                        React.createElement(TextWrapper, { isEmblem: this.state.style === 'normal_emblem' },
                            React.createElement(LeftColumn, { isEdit: true, className: 'left-column' },
                                React.createElement(WhitePostImageBlock, { fileRef: this.fileRef, uppy: this.uppy, style: style, isUpdate: true, onAddCard: this.handleUpdateWhitePostCard, onAddImage: this.addFile, onImageRemove: function () { return _this.onImageRemove(); }, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo), src: this.state.bigImageSrc, post: this.state.post })),
                            React.createElement(RightColumn, { className: 'right-column' },
                                React.createElement("div", { ref: this.textareaRef },
                                    React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onStandartTextareaChange(e); }, placeholder: t('editor.inputs.placeholder'), onResize: this.onStandartTextareaResize, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, maxLength: '2400' // old value = 1000
                                        , autoFocus: true }),
                                    additionalStyle !== '' && (React.createElement(ButtonBlock, { data: buttons, uprise: UPRISE_TYPE.normal, type: additionalStyle, onAddNewButton: this.handlePostButtonsChange, onDeleteButton: this.handleDeleteButton, postId: (_1 = this.props.post) === null || _1 === void 0 ? void 0 : _1.postId, isEdited: true, setDropdownOpen: this.setDropdownOpen }))),
                                this.state.post.attachments.length > 0 ? (React.createElement("div", null, ((_2 = this.state.post.attachments[0].file) === null || _2 === void 0 ? void 0 : _2.isDeleted) ===
                                    false ? (React.createElement(AttachmentsWrap, null,
                                    React.createElement(AttachedImage, { isLoading: this.state.isLoading },
                                        React.createElement("label", null,
                                            React.createElement("img", { src: bigImageUrl, alt: 'prev' }),
                                            React.createElement("div", { className: 'image__hover' }, "Replace Image"),
                                            React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: this.imageRef, onChange: function (e) { return _this.addFile(e, 'small'); } }))),
                                    React.createElement(RemoveImage, { onClick: function () { return _this.onImageRemove(); } }))) : (''))) : (''),
                                this.state.prevImageSrc === '' ? ('') : (React.createElement(AttachmentsWrap, null,
                                    React.createElement(AttachedImage, { isLoading: this.state.isLoading },
                                        React.createElement(AttachedImageProgress, { isLoading: this.state.isLoading },
                                            React.createElement(ProgressBar, { uppy: this.uppy, hideAfterFinish: true })),
                                        React.createElement("label", null,
                                            React.createElement("img", { src: this.state.prevImageSrc, alt: 'prev' }),
                                            React.createElement("div", { className: 'image__hover' }, "Replace Image"),
                                            React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: this.imageRef, onChange: function (e) { return _this.addFile(e, 'small'); } }))),
                                    React.createElement(ImageCaption, null,
                                        React.createElement(TextArea, { value: this.state.imageCaption, onChange: function (e) {
                                                return _this.setState({ imageCaption: e.target.value });
                                            }, placeholder: t('editor.add_caption_placeholder') })),
                                    React.createElement(RemoveImage, { onClick: function () { return _this.onImageRemove(); } })))))))),
                isBottom && editorToolbar),
            caption && postTextPos === 'caption-bottom' && (React.createElement(CaptionBlock, { colorStyle: captionColorStyle },
                React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(caption))))));
    };
    return UpdateEl;
}(Component));
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var toggleLongReadPostUpdate = getToggleLongReadPostUpdate(store, currentId);
    var newLongread = getCurrentLongread(store, currentId);
    return {
        // countryInnerPageData: store.countryInnerPage.data,
        updateStatus: toggleLongReadPostUpdate.updateStatus,
        alreadyHasImageSources: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'image_sources'; })
            : false,
        alreadyHasBibliography: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'bibliography'; })
            : false,
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var currentId = _a.lgid;
    return {
        // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
        addLongReadPost: function (_a) {
            var id = _a.id, title = _a.title, text = _a.text, color = _a.color, imageid = _a.imageid, lgid = _a.lgid, generalProps = _a.generalProps;
            return dispatch(addLongReadPost({ id: id, title: title, text: text, color: color, imageid: imageid, lgid: lgid, generalProps: generalProps }));
        },
        getLongReadPosts: function (idUser, idLongRead, sign, thematic) {
            return dispatch(getLongReadPosts(idUser, idLongRead, sign, thematic));
        },
        toggleLongReadPostUpdate: function (postid, updateStatus) {
            return dispatch(toggleLongReadPostUpdate(postid, updateStatus, currentId));
        },
        updateLongReadPost: function (imageid, post) {
            return dispatch(updateLongReadPost(imageid, post));
        },
        deleteLongReadPost: function (id, idUser, idLongRead, sign) {
            return dispatch(deleteLongReadPost(id, idUser, idLongRead, sign));
        },
        toggleWidePreviewer: function (val, src) {
            return dispatch(toggleWidePreviewer(val, src));
        },
        clearWidePreviewer: function () {
            return dispatch(clearWidePreviewer());
        }
    };
};
UpdateEl.propTypes = {};
export default connect(mapStateToProps, mapDispatchToProps)(toastHook(withProfile(withModal(withLocalization(UpdateEl))), useToasts));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
/*

<ImageCaption>
                                <TextareaAutosize value={this.state.imageCaption}
                                                  onChange={(e) => this.setState({ imageCaption: e.target.value })}
                                                  placeholder='Add caption'
                                />
                              </ImageCaption>



                      {
                        this.state.text.length > 50 && this.state.isFirstLetter ?
                        <RemoveLetterBtn onClick={() => this.toggleFirstLetter(false)} /> :
                        this.state.text.length > 50 && !this.state.isFirstLetter ?
                        <AddLetterBtn onClick={() => this.toggleFirstLetter(true)} /> :
                        ''
                      }
*/
/*
const uppy = new Uppy({
  meta: { type: 'image/jpeg' },
  restrictions: { maxNumberOfFiles: 1 },
  autoProceed: true
})

uppy.use(Tus, { endpoint: 'https://test5.swarm.store/upload/' })
*/
/*
Старый дизайн


const Top = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`

const Bottom = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`

const ButtonClose = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${close}) no-repeat center;
`

const ButtonAddImage = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addimage}) no-repeat center;
`

const ButtonAddVideo = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addvideo}) no-repeat center;
`

const ButtonAddPubl = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addpubl}) no-repeat center;
`

const ButtonAddWide = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addwide}) no-repeat center;
`

const ButtonAddSection = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addsection}) no-repeat center;
`

const Border = styled.div`
  width: 2px;
  height: 66px;
  margin-right: 15px;
  background: white;
`

const SectionNameText = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 63px;
  line-height: 72px;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  margin-bottom: 15px;
`
const SelectName = styled.div`
  color: black;
  display: inline-block;
  position: relative;
  cursor: pointer;
  &:after {
    content: '';
    display: inline-block;
    position: relative;
    width: 22px;
    height: 22px;
    background: url(${arr}) no-repeat center;
    top: -10px;
    margin-left: 10px;
  }
`



*/
//# sourceMappingURL=updateel.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT } from "../../../../constants/media";
import removeimage from '../../../../images/icons/longreadeditor/deleteimage.svg';
import removeimagehover from '../../../../images/icons/longreadeditor/deleteimagehover.svg';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import { updateLongReadPost } from '../../../../actions/updateLongReadPost';
import { deleteLongReadPost } from '../../../../actions/deleteLongReadPost';
import { colorObj } from '../../../../constants/colorObj';
import urlApi from '../../../../actions/urlApi';
import { paddings, heights } from '../../../../constants/paddings';
import BigImageComp from './bigimage';
import ColorMenuComp from './colormenu';
import { throttle } from './throttle';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import { Endpoints } from "@brg/api";
import FileInput from '@uppy/file-input';
import EditorToolbar from './EditorToolbar';
import CaptionEdit from './CaptionEdit';
import { CaptionBlock } from '../postblocks/coloredblock';
import { CaptionMarkdownText, LeftColumn, RightColumn, TextWrapper } from "../postblocks/whitepostblock";
import TextArea, { TEXTAREA_TYPE } from '../../modules/inputs/TextArea';
import formatLinks from '../../../../utilites/formatLinks';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import toastHook from '../../../../utilites/toasts';
import { Colors, FlexBox, useToasts } from '@brg/ui';
import { EditorWrap, EditTitle } from './newel';
import { getAppNameFromAppString } from '../../../../utilites/appTester';
import { withModal } from '../../../../core/modules/modal.module';
import { withLocalization } from '../../../../hooks/useLocalization';
import { HeaderToggle } from "../postblocks/bibliographyblock";
import { getGalllleryUrl } from "../../../../actions/getGalllleryUrl";
import { FirstAsCoverBlock } from './FirstAsCover/FirstAsCoverBlock';
import VotePostBlock from '../postblocks/VoteBlock/votepostblock';
import { SliderEditBlock } from './SiderEditBlock/SliderEditBlock';
import { PresentationBlock } from './Presentation/PresentationBlock';
import { withProfile } from '../../../../hooks/withProfile';
import { bProfile } from '@brg/auth';
import { ProjectEditBlock } from "./ProjectEditBlock/ProjectEditBlock";
import Votepostwithcollect from '../postblocks/VoteBlock/votepostwithcollect';
import ButtonBlock from './Button';
import { BUTTON_TYPE, UPRISE_TYPE } from './Button/const';
import FormsBlock, { FORM_CENTER_POS } from '../postblocks/FormsBlock/FormsBlock';
import { LINK_BUTTON_TYPE } from './Button/Button';
import { getToggleLongReadPostUpdate } from "../../../../reducers/toggleLongReadPostUpdate";
import { LessonEditBlock } from "../postblocks/CourseBlock/sections/LessonEditBlock";
import ProductsBlock from '../postblocks/ProductsBlock/ProductsBlock';
import { CoursePresentationEditBlock } from "./CoursePresentationEditBlock/CoursePresentationEditBlock";
import TwoPicturesBlock from './TwoPicturesBlock/TwoPicturesBlock';
import RadioButton from "../../../buttons/Radio";
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import BigImageCard from "./bigimageCard";
import { addOrChangeAdditionalInfo } from "../../../../utilites/addOrChangeAdditionalInfo";
import { getAdditionalInfoVal } from "../../../../utilites/getAdditionalInfoVal";
import { PodcastEditBlock } from "./PodcastEditBlock/PodcastEditBlock";
import { onChangeBibliography } from '../../../../utilites/bibliography/onChangeBibliography';
import { modifyToListText } from '../../../../utilites/bibliography/modifyToListText';
import { getCardIdsFromAdditionalInfo } from '../../../../utilites/card/getCardIdsFromAdditionalInfo';
import { getIsPayFromPost } from '../../../../utilites/card/getIsPayFromPost';
import { updateIsPayInCardsInfo } from '../../../../utilites/card/updateIsPayInCardsInfo';
import { CARDS_INFO_KEY } from '../../../../constants/cards';
import { INITIAL_RAITING, RaitingBox } from '../postblocks/components/RaitingBox';
import { clearWidePreviewer, toggleWidePreviewer } from '../../../../actions/toggleWidePreviewer';
import { WhitePostImageBlock } from './WhitePostImageBlock/WhitePostImageBlock';
import LinkArea from '../../modules/inputs/LinkArea';
import { extractProjectId, replaceAWithHref } from '../../../../utilites/replaceHiddenProjectLink';
import { BlockWithTitleEdit } from './AnnotationEditor/BlockWithTitleEdit';
import { getTileViewType } from '../../../../constants/TyleViewType';
var MAX_FILES_COUNT = 15;
var Wrap = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  max-width: min-content;\n  min-width: 1152px;\n  margin-top: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  //margin-top: 40px;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  margin-bottom: ", ";\n   z-index: ", ";\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n  transition: all 1s;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    // $ {({ fixWidth }) => fixWidth ? css\n    //   max-width: 888px;\n    //  : null};\n    min-width: 888px\n  }\n\n  ", ";\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 0.5s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"], ["\n\n  max-width: min-content;\n  min-width: 1152px;\n  margin-top: ", ";\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  //margin-top: 40px;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  margin-bottom: ", ";\n   z-index: ", ";\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n  transition: all 1s;\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    // $ {({ fixWidth }) => fixWidth ? css\n    //   max-width: 888px;\n    //  : null};\n    min-width: 888px\n  }\n\n  ", ";\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 0.5s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"])), function (props) {
    return (props === null || props === void 0 ? void 0 : props.withHeader) ? '16px' : '40px';
}, function (props) {
    return (props === null || props === void 0 ? void 0 : props.withHeader) ? '16px' : '40px';
}, function (p) { return (p === null || p === void 0 ? void 0 : p.hideBackground) ? 'transparent' : '#ffffff'; }, function (props) {
    return props.updateStatus === 'caption' ? /*'40px'*/ '0' : '0';
}, function (props) { return props.zIndex; }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (_a) {
    var isGalllleryNewStyle = _a.isGalllleryNewStyle;
    return isGalllleryNewStyle && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "], ["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "])));
}, function (_a) {
    var hideBackground = _a.hideBackground;
    return hideBackground ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject([" margin-top: 0;"], [" margin-top: 0;"]))) : null;
});
var AttachedImageProgress = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"])), function (props) { return (props.isLoading ? 'block' : 'none'); });
var RemoveImage = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"], ["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  transition: 0.2s;\n  opacity: 0.31;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"])), removeimage, removeimagehover);
export var UpdateHeaderToggle = styled(HeaderToggle)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width: ", ";\n  width: 100%;\n  margin-top: 40px;\n  margin-bottom: 0px;\n  color: ", ";\n  position: ", ";\n  z-index: ", ";\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    max-width: 888px;\n    margin: 40px auto 0 auto;\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 16px;\n  }\n"], ["\n  max-width: ", ";\n  width: 100%;\n  margin-top: 40px;\n  margin-bottom: 0px;\n  color: ", ";\n  position: ", ";\n  z-index: ", ";\n\n  @media (max-width: ", "px), (max-height: ", "px) {\n    max-width: 888px;\n    margin: 40px auto 0 auto;\n  }\n  @media (max-width: ", "px) {\n    margin-bottom: 16px;\n  }\n"])), function (_a) {
    var viewType = _a.viewType, isModal = _a.isModal;
    return (['fluid', 'fixed-ratio-large', 'free-type'].includes(viewType) && !isModal) ? LayoutConst.container.l + 'px' : 'none';
}, function (props) { return ((props === null || props === void 0 ? void 0 : props.isModal) ? '#FFFFFF' : (props === null || props === void 0 ? void 0 : props.colorStyle) === 'light' ? Colors.galBlack100 : Colors.geoWhite100); }, function (props) { return ((props === null || props === void 0 ? void 0 : props.isModal) ? 'relative' : 'inherit'); }, function (props) { return ((props === null || props === void 0 ? void 0 : props.isModal) ? '101' : 'auto'); }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, LayoutConst.container.s);
var AttachedImage = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  padding-right: 30px;\n\n  .image__hover {\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 30px;\n    border: 4px solid #f1db63;\n    background: linear-gradient(\n      0deg,\n      rgba(21, 21, 20, 0.47),\n      rgba(21, 21, 20, 0.47)\n    );\n    align-items: center;\n    justify-content: center;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 20px;\n    line-height: 32px;\n    text-align: center;\n    letter-spacing: -0.02em;\n    color: #fefefe;\n    cursor: pointer;\n    z-index: 10;\n    transition: 0.2s;\n  }\n\n  img:hover + .image__hover {\n    display: flex;\n  }\n\n  .image__hover:hover {\n    display: flex;\n  }\n\n  input[type='file'] {\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"], ["\n  position: relative;\n  padding-right: 30px;\n\n  .image__hover {\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 30px;\n    border: 4px solid #f1db63;\n    background: linear-gradient(\n      0deg,\n      rgba(21, 21, 20, 0.47),\n      rgba(21, 21, 20, 0.47)\n    );\n    align-items: center;\n    justify-content: center;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 20px;\n    line-height: 32px;\n    text-align: center;\n    letter-spacing: -0.02em;\n    color: #fefefe;\n    cursor: pointer;\n    z-index: 10;\n    transition: 0.2s;\n  }\n\n  img:hover + .image__hover {\n    display: flex;\n  }\n\n  .image__hover:hover {\n    display: flex;\n  }\n\n  input[type='file'] {\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"])), function (props) { return (props.isLoading ? '0.5' : '1'); });
var ImageCaption = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-top: 16px;\n\n  textarea {\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #151514;\n\n    &:focus {\n      opacity: 1;\n    }\n  }\n"], ["\n  margin-top: 16px;\n\n  textarea {\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 15px;\n    line-height: 20px;\n    color: #151514;\n\n    &:focus {\n      opacity: 1;\n    }\n  }\n"])));
var AttachmentsWrap = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var uploadValidator = function (_a) {
    var files = _a.files, toasts = _a.toasts, isWideImageType = _a.isWideImageType, profile = _a.profile, isComment = _a.isComment, style = _a.style, isLMS = _a.isLMS;
    return __awaiter(void 0, void 0, void 0, function () {
        var isModer, failedChecks, loadFile, MAX_MP3_FILE_SIZE, allowedAudioTypes, _b, height, width, ratio, MAX_GIF_FILE_SIZE, MAX_JPEG_FILE_SIZE, MAX_PNG_FILE_SIZE, failedSize, failedDimensions, failedRatio;
        var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    isModer = bProfile.isModer(profile);
                    failedChecks = {};
                    loadFile = function () {
                        return new Promise(function (resolve, reject) {
                            var fr = new FileReader();
                            fr.onload = function () {
                                // file is loaded
                                var img = new Image();
                                img.onload = function () {
                                    var width = img.width, height = img.height;
                                    resolve({
                                        width: width,
                                        height: height
                                    });
                                };
                                // @ts-ignore
                                img.src = fr.result; // is the data URL because called with readAsDataURL
                            };
                            fr.readAsDataURL(files[0]);
                        });
                    };
                    if (style === 'podcast') {
                        MAX_MP3_FILE_SIZE = 157286400;
                        allowedAudioTypes = ['audio/mpeg', 'audio/wav', 'audio/x-wav', 'audio/wave'];
                        if (!allowedAudioTypes.includes((_c = files === null || files === void 0 ? void 0 : files[0]) === null || _c === void 0 ? void 0 : _c.type)) {
                            toasts.error('Загрузите mp3 файл');
                            return [2 /*return*/, false];
                        }
                        if (((_d = files === null || files === void 0 ? void 0 : files[0]) === null || _d === void 0 ? void 0 : _d.size) > MAX_MP3_FILE_SIZE) {
                            toasts.error('Максимальный размер mp3 - 150 МБ');
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, loadFile()];
                case 1:
                    _b = _o.sent(), height = _b.height, width = _b.width;
                    if ((height >= width && (height > 5262 || width > 3720)) ||
                        (width > height && (height > 3720 || width > 5262))) {
                        toasts.error('Максимальные размеры изображения - 3720х5262 и 5262x3720');
                        failedChecks.dimensions = true;
                    }
                    ratio = width / height;
                    if (isComment || isLMS) {
                    }
                    else if (isWideImageType) {
                        // const isSmallWideImage = ratio > 1.47 && ratio < 1.49
                        // const isLargeWideImage = ratio > 1.79 && ratio < 1.81
                        // if (!isSmallWideImage && !isLargeWideImage) {
                        //   toasts.error(
                        //     'Изображение неправильное (отношение ширины к высоте должно быть или 1.48, или 1.8)'
                        //   )
                        //   failedChecks.ratio = true
                        // }
                    }
                    else {
                        if (ratio < 0.6 && style !== 'two_pictures') {
                            toasts.error('Изображение слишком длинное (отношение ширины к высоте должно быть 0.6 и более)');
                            failedChecks.ratio = true;
                        }
                    }
                    MAX_GIF_FILE_SIZE = 20971520;
                    MAX_JPEG_FILE_SIZE = 157286400;
                    MAX_PNG_FILE_SIZE = 20971520;
                    if ((((_e = files === null || files === void 0 ? void 0 : files[0]) === null || _e === void 0 ? void 0 : _e.type) === 'image/jpeg' || ((_f = files === null || files === void 0 ? void 0 : files[0]) === null || _f === void 0 ? void 0 : _f.type) === 'image/jpg') &&
                        ((_g = files === null || files === void 0 ? void 0 : files[0]) === null || _g === void 0 ? void 0 : _g.size) > MAX_JPEG_FILE_SIZE) {
                        toasts.error('Максимальный размер jpeg-файла - 150Мб');
                        failedChecks.size = true;
                    }
                    if (((_h = files === null || files === void 0 ? void 0 : files[0]) === null || _h === void 0 ? void 0 : _h.type) === 'image/png' &&
                        ((_j = files === null || files === void 0 ? void 0 : files[0]) === null || _j === void 0 ? void 0 : _j.size) > MAX_PNG_FILE_SIZE) {
                        toasts.error('Максимальный размер png-файла - 20Мб');
                        failedChecks.size = true;
                    }
                    if (((_k = files === null || files === void 0 ? void 0 : files[0]) === null || _k === void 0 ? void 0 : _k.type) === 'image/gif' &&
                        ((_l = files === null || files === void 0 ? void 0 : files[0]) === null || _l === void 0 ? void 0 : _l.size) > MAX_GIF_FILE_SIZE) {
                        toasts.error('Максимальный размер gif-файла - 20Мб');
                        failedChecks.size = true;
                    }
                    if (!__spreadArray(['image/jpeg', 'image/jpg', 'image/gif', 'image/png'], (isModer ? ['image/png'] : []), true).includes((_m = files === null || files === void 0 ? void 0 : files[0]) === null || _m === void 0 ? void 0 : _m.type)) {
                        toasts.error('Допустимые форматы: jpg, png, gif');
                        failedChecks.size = true;
                    }
                    failedSize = failedChecks.size, failedDimensions = failedChecks.dimensions, failedRatio = failedChecks.ratio;
                    if (failedSize || failedDimensions || failedRatio) {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
            }
        });
    });
};
var UpdateEl = /** @class */ (function (_super) {
    __extends(UpdateEl, _super);
    function UpdateEl(props) {
        var _this = this;
        var _a, _b, _c, _d;
        _this = _super.call(this, props) || this;
        _this.handlePostButtonsChange = function (button) {
            _this.setState({ buttons: [button] });
        };
        _this.setBigImage = function () {
            if (_this.props.post.attachments.length > 0) {
                if (_this.props.post.style === 'image' ||
                    _this.props.post.style === 'big' ||
                    _this.props.post.style === 'as_cover') {
                    var bigImageSrc = _this.props.post.attachments[0].file &&
                        _this.props.post.attachments[0].file.url
                        ? "".concat(urlApi().getImageQueryLink()).concat(_this.props.post.attachments[0].file.url)
                        : '';
                    if (bigImageSrc) {
                        _this.setState({ bigImageSrc: bigImageSrc });
                    }
                }
            }
        };
        _this.handleClickOutside = function (event) {
            if (_this.wrapperRef &&
                !_this.wrapperRef.current.contains(event.target) &&
                _this.state.text.length > 0) {
                // this.props.toggleLongReadPostUpdate(0, false)
                /* вариант с сохранением поста */
                _this.updateLongReadPost();
            }
        };
        _this.updateLongReadLessonPost = function () {
            if (!_this.state.onLessonSave)
                return;
            _this.state.onLessonSave().then(function (r) { return _this.updateLongReadPost(false, r); });
        };
        _this.handleTitleBlock = function () {
            _this.setState({ style: 'block_with_title' });
        };
        _this.handleTextareaFocus = function (e) {
            var _a, _b, _c, _d;
            if (_this.state.secondaryStyle !== '') {
                return false;
            }
            var defaultTA = (_b = (_a = _this.textareaRef.current) === null || _a === void 0 ? void 0 : _a.firstChild) === null || _b === void 0 ? void 0 : _b.firstChild;
            defaultTA && defaultTA.focus();
            if (!_this.state.useRating) {
                var coloredTA = (_d = (_c = _this.coloredTextareaRef.current) === null || _c === void 0 ? void 0 : _c.firstChild) === null || _d === void 0 ? void 0 : _d.firstChild;
                coloredTA && coloredTA.focus();
            }
        };
        _this.onCaptionChange = function (e) {
            var height = e.target.offsetHeight;
            var htmlValue = e.target.value.substring(0, 800);
            var textLength = e.target.value;
            var linkProjectId = extractProjectId(htmlValue);
            _this.setState({
                caption: htmlValue,
            }, function () {
                if (textLength > 800) {
                    _this.props.toasts.error('Максимальная длина: 800 символов');
                }
            });
        };
        _this.onLinkResize = function (e) {
            _this.setState({
                text: e.target.value
            }, function () {
                if (_this.state.text.length > 200) {
                    _this.props.toasts.error('Максимальная длина: 200 символов');
                    _this.setState({
                        text: e.target.value.substring(0, 200),
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal',
                        linkText: _this.state.linkText
                    });
                }
            });
            if (_this.state.text.length > 200) {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal'
                    });
                });
            }
            setTimeout(function () { return _this.setSizes(); });
        };
        _this.handleSetLink = function (link) {
            var linkProjectId = extractProjectId(link);
            _this.setState({ linkText: link, linkProjectId: linkProjectId });
        };
        _this.onSourcesTextareaKeyUp = function (e) {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { text: modifyToListText(prevState.text, e) })); });
        };
        _this.replaceHiddenProjectLink = function (id, field) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = urlApi()) === null || _a === void 0 ? void 0 : _a.getProject({ id: id }).then(function (r) { return r.status === 200 && r.json(); }).then(function (project) {
                            var _a;
                            var _b, _c;
                            var isHiddenProject = project.status === 10;
                            if (isHiddenProject) {
                                _this.props.toasts.error('Нельзя добавить ссылку на скрытый проект');
                            }
                            _this.setState((_a = {},
                                _a[field] = isHiddenProject ? replaceAWithHref((_b = _this.state) === null || _b === void 0 ? void 0 : _b[field]) : (_c = _this.state) === null || _c === void 0 ? void 0 : _c[field],
                                _a.linkProjectId = '',
                                _a));
                        }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleResize = throttle(function () {
            _this.setSizes();
        }, 1000);
        _this.handleProjects = function () {
            var _a;
            var _b = _this.props, maxProjects = _b.maxProjects, teamContexts = _b.teamContexts, teamExtraFilter = _b.teamExtraFilter, isPresentation = _b.isPresentation, onOpenSetProjectsModal = _b.onOpenSetProjectsModal;
            onOpenSetProjectsModal({
                maxProjects: maxProjects,
                teamContexts: teamContexts,
                teamExtraFilter: teamExtraFilter,
                isPresentation: isPresentation,
                alreadyProjects: ((_a = _this.state) === null || _a === void 0 ? void 0 : _a.projectIds) || [],
                onSelectProjects: function (projectIds) {
                    _this.setState({
                        projectIds: projectIds || []
                    });
                }
            });
        };
        _this.handleUpdateWhitePostCard = function () {
            var _a;
            var filterAI = (_a = _this.state.additionalInfo) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; });
            _this.setState({
                cardId: '',
                additionalInfo: filterAI
            });
            var _b = _this.props, modal = _b.modal, lgid = _b.lgid, num = _b.num, getLongReadPosts = _b.getLongReadPosts, setEditLongRead = _b.setEditLongRead, bookId = _b.bookId;
            modal.show('cardSelect', {
                themeColor: _this.props.colorStyle,
                onCardSelect: function (cardId) {
                    modal.hide();
                    _this.setState({
                        additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify([{ cardId: cardId, isPay: false }]) }]),
                        bigImageSrc: '',
                        style: 'normal_card'
                    });
                }
            });
        };
        _this.handleProductsButton = function () {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, setEditLongRead = _a.setEditLongRead, bookId = _a.bookId, teamId = _a.teamId;
            modal.show('productsSelect', {
                cardIds: getCardIdsFromAdditionalInfo(_this.state.additionalInfo, _this.state.cardIds),
                teamId: teamId,
                onSubmit: function (cardIds) {
                    var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
                    var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
                    modal.hide();
                    _this.setState({
                        additionalInfo: additionalInfoUpdated,
                        cardIds: cardIdsUpdated,
                        style: 'products'
                    });
                }
            });
        };
        _this.handleButtonLink = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-link' ? '' : 'button-link'
            });
        };
        _this.handleWhitePostImageButton = function (ev) {
            var _a, _b;
            var style = (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b['type'];
            _this.setState({
                style: style,
            });
        };
        _this.handleAnchorButton = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-anchor' ? '' : 'button-anchor'
            });
        };
        _this.handleDeleteButton = function (id) {
            var confirm = window.confirm('Вы действительно хотите удалить кнопку?');
            var toasts = _this.props.toasts;
            if (confirm) {
                _this.setState({
                    // buttons: this.state.buttons?.filter((i) => i?.id !== id),
                    buttons: [],
                    secondaryStyle: '',
                }, function () {
                    toasts.info('Кнопка была удалена.');
                });
            }
        };
        _this.handleSetFormId = function (id) {
            _this.setState({
                formId: id,
            });
        };
        _this.handleAddForms = function () {
            _this.setState({
                style: 'forms'
            });
        };
        _this.handleAddLesson = function () {
            _this.setState({
                style: 'course_lesson'
            });
        };
        _this.handleAddPodcast = function () {
            _this.setState({
                style: 'podcast'
            });
        };
        _this.handleAddCoursePresentation = function () {
            _this.setState({
                style: 'course_presentation'
            });
        };
        _this.handleSetFormPosition = function (val) {
            _this.setState({
                formPosition: val,
            });
        };
        _this.handleCardButton = function (isImage) {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, toggleLongReadPostUpdate = _a.toggleLongReadPostUpdate, post = _a.post, bookId = _a.bookId, sign = _a.sign;
            if (_this.state.post.cardId)
                return;
            if (isImage) {
                urlApi().insertCardByImage({ postId: post.postId, longreadId: lgid }).then(function (res) {
                    setTimeout(function () {
                        getLongReadPosts('', lgid, sign);
                    }, 1000);
                    window.open(getGalllleryUrl() + '/card/' + (res === null || res === void 0 ? void 0 : res.cardId), '_blank');
                    // window.open(getGalllleryUrl() + '/collection/' + res?.collectionId + '?activeCard=' + res?.cardId, '_blank')
                });
                return;
            }
            modal.show('cardSelect', {
                onCardSelect: function (cardId) {
                    // toggleLongReadPostUpdate(0, false)
                    modal.hide();
                    _this.setState({
                        additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify([{ cardId: cardId, isPay: false }]) }]),
                        style: 'card'
                    });
                }
            });
        };
        _this.onChangeImage = function (event, index) { return __awaiter(_this, void 0, void 0, function () {
            var _a, toasts, profile, files, appName, allowed, _b;
            var _this = this;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, toasts = _a.toasts, profile = _a.profile;
                        files = (_c = Array.from(event.target.files)) === null || _c === void 0 ? void 0 : _c.slice(0, 1);
                        appName = getAppNameFromAppString(this.props.appName);
                        _b = ['geograffee', 'deziiign', 'competition'].includes(appName);
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadValidator({
                                files: files,
                                toasts: toasts,
                                profile: profile,
                                style: 'two_pictures',
                                isLMS: this.props.isLMS
                            })];
                    case 1:
                        _b = (_d.sent());
                        _d.label = 2;
                    case 2:
                        allowed = _b;
                        if (!allowed) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        this.uppy.reset();
                        files.forEach(function (file, i) {
                            var fr = new FileReader();
                            try {
                                _this.uppy.addFile({
                                    source: 'file input',
                                    name: file.name,
                                    type: file.type || 'application/octet-stream',
                                    data: file,
                                    meta: {
                                        contentType: file.type || 'application/octet-stream'
                                    }
                                });
                            }
                            catch (err) {
                                if (err.isRestriction) {
                                    // handle restrictions
                                    console.error('Restriction error:', err);
                                }
                                else {
                                    // handle other errors
                                    console.error(err);
                                }
                            }
                            fr.onload = function () {
                                var newImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                                newImg[index] = __assign(__assign({}, newImg[index]), { name: file.name, isUploaded: false, files: undefined, progress: 0, src: fr.result });
                                _this.setState({
                                    multiLoadGrouppedImg: newImg
                                });
                            };
                            fr.readAsDataURL(file);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleSortedProjects = function (projects) {
            _this.setState({
                projectIds: (projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return project === null || project === void 0 ? void 0 : project.id; })) || []
            });
        };
        _this.handleProductsChange = function (cardIds) {
            var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
            var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
            _this.setState({
                additionalInfo: additionalInfoUpdated,
                cardIds: cardIdsUpdated
            });
        };
        _this.handleSetCoursePresentation = function (projectId) {
            _this.setState({
                projectIds: [projectId]
            });
        };
        _this.handleDeleteProjects = function (deletedId) {
            var _a;
            var t = _this.props.t;
            if (!window.confirm(t('confirmation.project_block_item_delete')))
                return;
            _this.setState({
                projectIds: (_a = _this.state.projectIds) === null || _a === void 0 ? void 0 : _a.filter(function (id) { return id !== deletedId; })
            });
        };
        _this.handleImgRemove = function (id, name, needToConfirm) {
            var _a, _b, _c;
            var t = _this.props.t;
            if (needToConfirm) {
                if (!window.confirm(t('confirmation.image_delete')))
                    return;
            }
            var isEmpty = !((_b = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return ![i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); })) === null || _b === void 0 ? void 0 : _b.length);
            var isSpBlock = _this.state.style === 'super-puper-vote';
            var isSlider = _this.state.style === 'slider';
            // this.updateFileList(name)
            _this.setState({
                multiLoadGrouppedImg: (_c = _this.state.multiLoadGrouppedImg) === null || _c === void 0 ? void 0 : _c.filter(function (i) { return ![i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); }),
                spVoteError: isSpBlock
            });
            if (isEmpty && isSpBlock) {
                _this.setState({
                    multiLoadGrouppedImg: [],
                    multipleLoadSrc: [],
                    multipleLoadId: [],
                    spVoteError: false
                });
                _this.uppy.cancelAll();
                _this.uppy.reset();
            }
        };
        _this.handleTogglePostLikes = function (useRating) {
            return _this.setState({ useRating: useRating });
        };
        _this.handleToggleRatingDataChange = function (val, ev) {
            var _a;
            var _b;
            var target = ev.target;
            var value = val;
            var key = (_b = target === null || target === void 0 ? void 0 : target.dataset) === null || _b === void 0 ? void 0 : _b['key'];
            var data = _this.state.ratings;
            data = {
                custom: __assign(__assign(__assign({}, INITIAL_RAITING), data === null || data === void 0 ? void 0 : data.custom), (_a = {}, _a[key === 'name' ? 'name' : 'value'] = (key === 'name' ? value
                    : Number(value)), _a))
            };
            _this.setState({ ratings: data });
        };
        _this.handleSlideTextChange = function (id, text, textPosition) {
            var _a;
            var isPositionUpdate = text === 'updatePosition';
            var index = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.findIndex(function (i) { return [i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); });
            if (index === -1) {
                return;
            }
            var newArray = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
            newArray[index] = __assign(__assign(__assign({}, newArray[index]), (isPositionUpdate ? {} : { text: text })), { textPosition: textPosition });
            _this.setState({
                multiLoadGrouppedImg: newArray
            });
        };
        _this.handleTileViewTypeChange = function (type) {
            _this.setState({
                tileViewType: type
            });
        };
        _this.handleTextPositionChange = function (text, position) {
            if (position === 'caption' || position === 'caption-bottom') {
                _this.setState({
                    caption: text,
                    postTextPos: position,
                    text: ''
                });
            }
            else {
                _this.setState({
                    text: text,
                    postTextPos: position,
                    caption: '',
                });
            }
        };
        _this.handleSlideChecked = function (checked) {
            _this.setState({
                isRibbon: checked
            });
        };
        _this.handleSortedMultipleImgChange = function (list) {
            _this.setState({
                multiLoadGrouppedImg: __spreadArray([], list, true)
            });
        };
        _this.handleTogglePreviewer = function () {
            clearWidePreviewer();
        };
        _this.handleAddText = function (position) {
            var style = _this.state.style;
            var isSlider = style === 'slider';
            var isPresentation = (style === 'as_cover' || _this.props.post.style === 'as_cover') &&
                _this.props.isPresentation;
            if (!isSlider && !isPresentation) {
                _this.setState({
                    style: 'big',
                    postTextPos: position,
                    // caption: ''
                });
            }
            if (isPresentation) {
                _this.setState({
                    postTextPos: 'outside'
                });
            }
            if (isSlider) {
                _this.updatePostStatus('');
                _this.setState(function (_a) {
                    var editingText = _a.editingText, oldPosition = _a.position;
                    return ({
                        editingText: oldPosition === position ? editingText : !editingText,
                        editingCaption: false,
                        multiLoadCaptionMode: 'big',
                        postTextPos: position
                    });
                });
            }
        };
        _this.handleAnchorChange = function (text) {
            _this.setState({
                anchorText: text
            });
        };
        _this.setCaption = function (value) {
            _this.setState({ caption: value, postTextPos: 'caption-bottom', text: value, });
            _this.updatePostStatus(false);
        };
        _this.handleChangeAdditionalStyle = function () {
            _this.setState({ secondaryStyle: '' });
        };
        _this.updatePostStatus = function (style) {
            var _a = _this.props, toggleLongReadPostUpdate = _a.toggleLongReadPostUpdate, postId = _a.post.postId;
            toggleLongReadPostUpdate(postId, style);
        };
        var invertColor = function (bgColor, lightColor, darkColor) {
            var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
            var r = parseInt(color.substring(0, 2), 16); // hexToR
            var g = parseInt(color.substring(2, 4), 16); // hexToG
            var b = parseInt(color.substring(4, 6), 16); // hexToB
            return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
        };
        var defaultChooser = _this.props.post.style !== 'normal';
        var defaultText = _this.props.post.text;
        var defaultCaption = _this.props.post.attachments.length > 0
            ? _this.props.post.attachments[0].description
            : '';
        var defaultBgColor = ((_b = (_a = _this.props.post) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b[0]) === '#'
            ? _this.props.post.color
            : colorObj[_this.props.post.color];
        var defaultFontColor = ((_d = (_c = _this.props.post) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d[0]) === '#'
            ? invertColor(_this.props.post.color, 'white', '#151514')
            : colorObj.fonts[_this.props.post.color];
        // временно стайл, поскольку есть посты и со старыми стилями и с новыми
        var defaultStyle = function () {
            if (_this.props.post.style === '') {
                return 'normal';
            }
            if (_this.props.post.style === 'string') {
                if (_this.props.post.color === 'white' ||
                    _this.props.post.color === '#fff') {
                    return 'normal';
                }
                return 'colored';
            }
            return _this.props.post.style;
        };
        var multiLoadGrouppedImg = props.post.attachments.map(function (item) { return (__assign(__assign({}, item), { isUploaded: true })); });
        var getCaptionMode = function (p) { var _a, _b; return !!((_a = p.caption) === null || _a === void 0 ? void 0 : _a.length) ? 'small' : !!((_b = p === null || p === void 0 ? void 0 : p.text) === null || _b === void 0 ? void 0 : _b.length) ? 'big' : ''; };
        var getFormId = function (f) { var _a, _b, _c; return !!((_a = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) ? (_c = (_b = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (n) { return (n === null || n === void 0 ? void 0 : n.name) === 'formId'; })) === null || _c === void 0 ? void 0 : _c.value : ''; };
        var getFormPosition = function (f) { var _a, _b, _c; return !!((_a = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) ? (_c = (_b = f === null || f === void 0 ? void 0 : f.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (n) { return (n === null || n === void 0 ? void 0 : n.name) === 'formPosition'; })) === null || _c === void 0 ? void 0 : _c.value : FORM_CENTER_POS; };
        _this.state = {
            post: _this.props.post,
            text: defaultText,
            anchorText: _this.props.post.anchorText,
            postTextPos: _this.props.post.titlePosition,
            projectIds: _this.props.post.projectIds || [],
            title: _this.props.post.title,
            addButtonsOpened: false,
            color: defaultBgColor,
            linkProjectId: '',
            fontColor: defaultFontColor,
            isColorChoose: defaultChooser,
            colorName: _this.props.post.color,
            isTitleOpened: defaultChooser,
            imageId: '',
            tileViewType: getTileViewType(_this.props.post),
            buttonUpdated: false,
            formId: getFormId(_this.props.post),
            formPosition: getFormPosition(_this.props.post),
            imageCaption: defaultCaption,
            multiLoadGrouppedImg: multiLoadGrouppedImg,
            multiLoadCaptionMode: getCaptionMode(_this.props.post),
            caption: _this.props.post.caption,
            prevImageSrc: '',
            audioSrc: '',
            bigImageSrc: '',
            style: _this.props.post.style,
            isTextTooBig: defaultText.length > 2400,
            prevColorStatus: 'white',
            isFirstLetter: _this.props.post.isFirstLetter,
            isLoading: false,
            isRibbon: _this.props.post.isRibbon,
            coloredPadding: 57,
            secondaryStyle: '',
            buttons: _this.props.post.buttons || [],
            lessonPostDisabled: true,
            cardIds: _this.props.post.cardIds,
            useRating: _this.props.post.useRating,
            ratings: _this.props.post.ratings,
            linkText: _this.props.post.linkText,
            additionalInfo: _this.props.post.additionalInfo,
            onLessonSave: function () { },
            disablePosting: false,
            isDropdownOpen: false,
        };
        _this.fileRef = createRef();
        _this.standartTA = createRef();
        _this.imageRef = createRef();
        _this.bigimageRef = createRef();
        _this.coloredTA = createRef();
        _this.wrapperRef = createRef();
        _this.captionRef = createRef();
        _this.textareaRef = createRef();
        _this.coloredTextareaRef = createRef();
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        // потом возможно в отдельную сущность вынести
        var isSlider = _this.props.post.style === 'slider';
        _this.uppy = new Uppy({
            restrictions: { maxNumberOfFiles: isSlider ? MAX_FILES_COUNT : 1 },
            meta: { type: 'image/jpeg' },
            autoProceed: true,
            onBeforeUpload: function (files) {
                var _a, _b;
                var isSlider = _this.state.style === 'slider';
                var isTile = _this.state.style === 'tile';
                var isTwoPictures = _this.state.style === 'two_pictures';
                var total = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length;
                var maxFiles = isTwoPictures ? 2 : isTile ? 9 : MAX_FILES_COUNT;
                var isMaxFilesCount = (isSlider || isTile || (isTwoPictures && !((_b = _this.state.multiLoadGrouppedImg) === null || _b === void 0 ? void 0 : _b.length))) && total > maxFiles;
                if (isMaxFilesCount) {
                    _this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E ".concat(isSlider ? 'cлайдов' : 'изображений', " - ").concat(maxFiles));
                    _this.setState({
                        multiLoadGrouppedImg: __spreadArray([], _this.state.multiLoadGrouppedImg, true).slice(0, maxFiles)
                    });
                }
                _this.setState({
                    isMultiLoad: isSlider || isTwoPictures || isTile,
                    isLoading: !(isSlider || isTwoPictures || isTile),
                });
            }
        })
            .use(Tus, {
            endpoint: "".concat(Endpoints.uploader, "/upload/"),
            chunkSize: 4194304
        })
            .use(FileInput, {
            target: _this.fileRef.current,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
            .use(FileInput, {
            target: _this.imageRef.current,
            id: 'imageRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
            .use(FileInput, {
            target: _this.bigimageRef.current,
            id: 'bigimage',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        });
        _this.uppy.on('file-added', function (file) {
            var isMultipleLoad = _this.state.style === 'slider' || _this.state.style === 'tile';
            /* Добавляем имя и дополнительные поля */
            if (isMultipleLoad) {
                var result = [];
                result.push.apply(result, __spreadArray(__spreadArray([], _this.state.multiLoadGrouppedImg, false), [{
                        name: file === null || file === void 0 ? void 0 : file.name,
                        isUploaded: false,
                        caption: '',
                        isCaptionSetted: false,
                        text: '',
                        isTextSetted: false,
                        progress: 0
                    }], false));
                _this.setState({
                    multiLoadGrouppedImg: result
                });
            }
        });
        _this.uppy.on('upload-progress', function (file, progress) {
            var _a;
            _this.setState({ disablePosting: true });
            if (_this.state.isMultiLoad) {
                var uppyState_1 = (_a = _this.uppy.getState()) === null || _a === void 0 ? void 0 : _a.files;
                setTimeout(function () {
                    var _loop_1 = function (key) {
                        var name_1 = uppyState_1[key].name;
                        var progress_1 = uppyState_1[key].progress.percentage;
                        /* Добавляем проценты прогресса */
                        // console.log(`PROGRESS FOR ${name} ->  ${progress}`)
                        var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                            var isUploaded = (i === null || i === void 0 ? void 0 : i.progress) === 100;
                            if (isUploaded) {
                                return i;
                            }
                            if ((i === null || i === void 0 ? void 0 : i.name) === name_1) {
                                return __assign(__assign({}, i), { progress: progress_1 });
                            }
                            return i;
                        });
                        _this.setState({
                            multiLoadGrouppedImg: result
                        });
                    };
                    for (var key in uppyState_1) {
                        _loop_1(key);
                    }
                }, 1500);
            }
        });
        _this.uppy.on('upload-success', function (file, response) {
            var _a;
            var isSuccess = ((_a = response === null || response === void 0 ? void 0 : response.uploadURL) === null || _a === void 0 ? void 0 : _a.length) > 1;
            setTimeout(function () {
                if (isSuccess) {
                    /* Добавляем поле об успешном добавлении */
                    var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                        if ((i === null || i === void 0 ? void 0 : i.name) === (file === null || file === void 0 ? void 0 : file.name)) {
                            return __assign(__assign({}, i), { isUploaded: true });
                        }
                        return i;
                    });
                    _this.setState({
                        multiLoadGrouppedImg: result
                    });
                }
            }, 1500);
        });
        _this.uppy.on('complete', function (result) {
            try {
                // то, что после загрузки картинки в уппи
                var fileData 
                // проверка есть ли файл
                = void 0;
                // проверка есть ли файл
                if (_this.props.post.attachments.length === 0) {
                    fileData = {
                        fileId: '',
                        containerId: 'string',
                        isNew: true,
                        type: 'string',
                        url: 'string',
                        size: 'string',
                        localization: 'string'
                    };
                }
                else {
                    fileData =
                        _this.props.post.attachments[0] &&
                            _this.props.post.attachments[0].file;
                }
                var url = result.successful[0].uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                var isSlider_1 = _this.state.style === 'slider' || _this.state.style === 'tile';
                var isPodcast = _this.state.style === 'podcast';
                var isTwoPictures = _this.state.style === 'two_pictures';
                if (isSlider_1) {
                    result.successful.forEach(function (item, idx) {
                        var url = item.uploadURL;
                        var linkT = url.split('/');
                        var lngh = linkT.length - 1;
                        var id = linkT[lngh];
                        var grouppedImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                        var imgIndex = grouppedImg.findIndex(function (i) {
                            return (i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name) && !(i === null || i === void 0 ? void 0 : i.isUploaded);
                        });
                        var newImg = [];
                        if (grouppedImg.find(function (i) { return (i === null || i === void 0 ? void 0 : i.id) === id; })) {
                            _this.props.toasts.error("\u0424\u0430\u0439\u043B \u0441 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C ".concat(item === null || item === void 0 ? void 0 : item.name, " \u0443\u0436\u0435 \u0431\u044B\u043B \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D"));
                            newImg = grouppedImg.filter(function (i, index) { return index !== imgIndex; });
                        }
                        else {
                            newImg = grouppedImg.map(function (i) {
                                if ((i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name)) {
                                    return __assign(__assign({}, i), { id: id });
                                }
                                return i;
                            });
                        }
                        _this.setState({
                            multiLoadGrouppedImg: newImg
                        });
                    });
                }
                else if (isTwoPictures) {
                    var newAttachments = _this.state.multiLoadGrouppedImg.reduce(function (acc, img) {
                        var uploaded = result.successful.find(function (_a) {
                            var name = _a.name;
                            return img.name === name;
                        });
                        if (!uploaded) {
                            return __spreadArray(__spreadArray([], acc, true), [img], false);
                        }
                        var url = uploaded.uploadURL;
                        var linkT = url.split('/');
                        var lngh = linkT.length - 1;
                        var id = linkT[lngh];
                        return __spreadArray(__spreadArray([], acc, true), [__assign(__assign({}, img), { file: {
                                    fileId: id, isNew: true
                                } })], false);
                    }, []);
                    _this.setState({
                        // imageId: id,
                        multiLoadGrouppedImg: newAttachments,
                        isLoading: false,
                        disablePosting: false
                    });
                }
                else {
                    var newAttach = __assign(__assign({}, _this.props.post.attachments[0]), { file: { fileData: fileData, fileId: id, isNew: true } });
                    var newAttachments = isPodcast ? [newAttach] : __spreadArray([newAttach], _this.props.post.attachments, true);
                    _this.setState({
                        imageId: id,
                        post: __assign(__assign({}, _this.props.post), { attachments: newAttachments }),
                        isLoading: false
                    });
                }
                _this.setState({ disablePosting: false });
            }
            catch (e) {
                console.error(e);
            }
        });
        _this.updateLongReadPost = _this.updateLongReadPost.bind(_this);
        _this.updateLongReadLessonPost = _this.updateLongReadLessonPost.bind(_this);
        _this.cancelUpdate = _this.cancelUpdate.bind(_this);
        _this.chooseColor = _this.chooseColor.bind(_this);
        _this.onColoredTextareaResize = _this.onColoredTextareaResize.bind(_this);
        _this.onStandartTextareaResize = _this.onStandartTextareaResize.bind(_this);
        _this.enableFirstLetter = _this.enableFirstLetter.bind(_this);
        _this.disableFirstLetter = _this.disableFirstLetter.bind(_this);
        _this.closeChooser = _this.closeChooser.bind(_this);
        _this.addText = _this.addText.bind(_this);
        _this.addFile = _this.addFile.bind(_this);
        _this.setBigImage = _this.setBigImage.bind(_this);
        _this.escFunction = _this.escFunction.bind(_this);
        _this.setDropdownOpen = _this.setDropdownOpen.bind(_this);
        return _this;
    }
    UpdateEl.prototype.setDropdownOpen = function (isOpen) {
        this.setState({ isDropdownOpen: isOpen });
    };
    UpdateEl.prototype.updateLongReadPost = function (isCardAbleToPurchase, customText) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var userid = localStorage.getItem('userId');
        var textLetter = this.state.isFirstLetter
            ? "".concat(this.state.text)
            : this.state.text;
        var slicedTextLetter = this.state.style === 'colored' ? textLetter.substring(0, 800) : textLetter;
        var isSlider = this.state.style === 'slider' || this.state.style === 'tile';
        var isTwoPictures = this.state.style === 'two_pictures';
        var isForm = this.state.style === 'forms';
        var finalStyle = ((_a = ['normal_image', 'normal_card']) === null || _a === void 0 ? void 0 : _a.includes(this.state.style)) ? 'normal' : this.state.style;
        // если добавили описание к картинки, добавляем
        var attachments = function () {
            if (_this.state.post.attachments.length === 0) {
                return [];
            }
            if (_this.state.style === 'normal_card') {
                return [];
            }
            if (isSlider) {
                return _this.state.multiLoadGrouppedImg.map(function (item) {
                    if (item === null || item === void 0 ? void 0 : item.files) {
                        return item;
                    }
                    return {
                        text: item === null || item === void 0 ? void 0 : item.text,
                        textPosition: item === null || item === void 0 ? void 0 : item.textPosition,
                        description: item === null || item === void 0 ? void 0 : item.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: {
                            fileId: "".concat(item.id),
                            containerId: 'string',
                            isNew: true,
                            type: 'string',
                            // url: data?.src,
                            url: 'string',
                            size: 'string',
                            localization: 'string'
                        }
                    };
                });
            }
            if (isTwoPictures) {
                return _this.state.multiLoadGrouppedImg.map(function (item) {
                    if (item === null || item === void 0 ? void 0 : item.files) {
                        return item;
                    }
                    return {
                        text: item === null || item === void 0 ? void 0 : item.text,
                        textPosition: item === null || item === void 0 ? void 0 : item.textPosition,
                        description: item === null || item === void 0 ? void 0 : item.caption,
                        isDeleted: true,
                        postAttachmentId: '',
                        referenceId: '',
                        type: 0,
                        file: __assign({ fileId: "".concat(item.fileId), containerId: 'string', isNew: true, type: 'string', 
                            // url: data?.src,
                            url: 'string', size: 'string', localization: 'string' }, item.file)
                    };
                });
            }
            var newAttach = __spreadArray([], _this.state.post.attachments, true);
            newAttach[0].description = _this.state.imageCaption;
            return newAttach;
        };
        var autoCaption = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(this.state.style)) ? this.state.caption :
            (this.state.postTextPos !== 'caption-bottom' ? '' : (this.state.caption || slicedTextLetter));
        var autoText = this.state.style === 'podcast' ? this.state.post.text : (this.state.style === 'projects' || this.state.postTextPos === 'caption-bottom') ? '' : (slicedTextLetter || this.state.caption);
        var ratings = !!this.state.useRating ? this.state.ratings : {};
        var newAdditionalInfo = this.state.additionalInfo;
        if (isCardAbleToPurchase !== undefined) {
            newAdditionalInfo = addOrChangeAdditionalInfo(newAdditionalInfo, [
                { "name": CARDS_INFO_KEY, "value": updateIsPayInCardsInfo(newAdditionalInfo, isCardAbleToPurchase ? true : false) },
                { "name": "projectId", "value": (_c = this.props) === null || _c === void 0 ? void 0 : _c.projectId },
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
        }
        if (isForm)
            newAdditionalInfo = addOrChangeAdditionalInfo(newAdditionalInfo, [
                { "name": "formId", "value": this.state.formId },
                { "name": "formPosition", "value": this.state.formPosition },
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
        if (this.state.style === 'normal_image') {
            newAdditionalInfo = (_d = this.state.additionalInfo) === null || _d === void 0 ? void 0 : _d.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; });
        }
        if (this.state.style === 'tile') {
            newAdditionalInfo = addOrChangeAdditionalInfo(newAdditionalInfo, [
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
        }
        // формирование нового поста и отправка
        this.setState(__assign(__assign({}, (isForm ? { isLoading: true } : {})), { post: __assign(__assign({}, this.state.post), { additionalInfo: newAdditionalInfo, text: (customText || autoText), projectIds: this.state.projectIds, titlePosition: this.state.postTextPos, color: this.state.colorName, title: this.state.title, isFirstLetter: this.state.isFirstLetter, style: finalStyle, caption: autoCaption, loadAdditionalImage: isSlider || isTwoPictures, attachments: attachments(), anchorText: this.state.anchorText, buttons: this.state.buttons, cardIds: this.state.cardIds, useRating: this.state.useRating, ratings: ratings, isRibbon: this.state.isRibbon, linkText: this.state.linkText }) }), function () {
            _this.props.updateLongReadPost(_this.state.imageId, _this.state.post);
            _this.props.toggleLongReadPostUpdate(0, false);
        });
        var isEmblem = this.state.style;
        var timeout = ((_e = attachments()) === null || _e === void 0 ? void 0 : _e.length) && !isEmblem ? 5000 : 1000;
        setTimeout(function () {
            return _this.props.getLongReadPosts(userid, _this.props.lgid, _this.props.thematic);
        }, timeout);
        this.uppy.reset();
    };
    UpdateEl.prototype.enableFirstLetter = function () {
        var text = this.state.text;
        this.setState({
            isFirstLetter: true,
            firstLetter: text[0],
            text: this.state.text.substring(1)
        });
    };
    UpdateEl.prototype.disableFirstLetter = function () {
        this.setState({
            isFirstLetter: false,
            text: "".concat(this.state.text),
            firstLetter: ''
        });
    };
    UpdateEl.prototype.onImageRemove = function () {
        var _this = this;
        var _a;
        if ((_a = ['normal_image', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(this.state.style)) {
            this.setState({
                imageId: '',
                imageCaption: '',
                prevImageSrc: '',
                bigImageSrc: '',
                audioSrc: '',
                post: __assign(__assign({}, this.props.post), { attachments: [] })
            });
            this.uppy.reset();
            return;
        }
        var attachments = function () {
            var newAttach = __assign(__assign({}, _this.state.post.attachments[0]), { file: __assign(__assign({}, _this.state.post.attachments[0].file), { isDeleted: true }) });
            var newAttachments = __spreadArray([], _this.state.post.attachments, true);
            newAttachments.splice(0, 1, newAttach);
            return newAttachments;
        };
        this.setState({
            imageId: '',
            imageCaption: '',
            prevImageSrc: '',
            audioSrc: '',
            post: __assign(__assign({}, this.state.post), { attachments: attachments() })
        });
        this.uppy.reset();
    };
    UpdateEl.prototype.chooseColor = function (color, isUserColor, hex) {
        var calcStyle = this.state.style === "link" ? 'link' :
            this.state.style === 'annotation' ? 'annotation' : 'colored';
        if (isUserColor && this.state.style === "link") {
            if (hex && hex.startsWith('#')) {
                var projectId = this.props.projectId || this.props.lgid;
                var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                localStorage.setItem(storageKey, hex);
            }
            var invertColor = function (bgColor, lightColor, darkColor) {
                var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
                var r = parseInt(color.substring(0, 2), 16); // hexToR
                var g = parseInt(color.substring(2, 4), 16); // hexToG
                var b = parseInt(color.substring(4, 6), 16); // hexToB
                return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
            };
            this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(this.state.text),
                firstLetter: '',
                style: calcStyle,
                prevColorStatus: hex,
                linkText: this.state.linkText
            });
        }
        else if (isUserColor) {
            if (hex && hex.startsWith('#')) {
                var projectId = this.props.projectId || this.props.lgid;
                var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                localStorage.setItem(storageKey, hex);
            }
            var invertColor = function (bgColor, lightColor, darkColor) {
                var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
                var r = parseInt(color.substring(0, 2), 16); // hexToR
                var g = parseInt(color.substring(2, 4), 16); // hexToG
                var b = parseInt(color.substring(4, 6), 16); // hexToB
                return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
            };
            this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(this.state.text),
                firstLetter: '',
                style: calcStyle,
                prevColorStatus: hex
            });
        }
        else {
            this.setState({
                color: colorObj[color],
                isTitleOpened: true,
                fontColor: colorObj.fonts[color],
                colorName: color,
                isFirstLetter: false,
                text: "".concat(this.state.text),
                firstLetter: '',
                prevColorStatus: color,
                style: calcStyle
            });
        }
    };
    UpdateEl.prototype.onColoredTextareaResize = function (e) {
        var _this = this;
        var _a, _b, _c, _d;
        var height = e.target.offsetHeight;
        var htmlValue = e.target.value;
        var textLength = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length;
        var linkProjectId = extractProjectId(htmlValue);
        var maxLengthRules = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(this.state.style)) ? 75 : 800;
        var calcStyle = ((_c = ['annotation', 'block_with_title']) === null || _c === void 0 ? void 0 : _c.includes(this.state.style)) ?
            this.state.style : 'normal';
        var calcValue = ((_d = ['annotation', 'block_with_title']) === null || _d === void 0 ? void 0 : _d.includes(this.state.style)) ?
            htmlValue === null || htmlValue === void 0 ? void 0 : htmlValue.substring(0, maxLengthRules) : htmlValue;
        this.setState({
            text: e.target.value,
            linkProjectId: linkProjectId,
        });
        if (textLength > maxLengthRules) {
            this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043B\u0438\u043D\u0430: ".concat(maxLengthRules, " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"));
            setTimeout(function () {
                return _this.setState({
                    text: e.target.value.substring(0, 2400),
                    color: colorObj.white,
                    isTitleOpened: false,
                    fontColor: colorObj.fonts.white,
                    isTextTooBig: true,
                    isColorChoose: false,
                    prevColorStatus: _this.state.colorName,
                    colorName: 'white',
                    style: calcStyle
                });
            });
        }
        setTimeout(function () { return _this.setSizes(); });
    };
    UpdateEl.prototype.onSourcesTextareaChange = function (e) {
        var _this = this;
        onChangeBibliography(e, this.state.style, function (val) { return _this.props.toasts.error(val); }, function (val) { return _this.setState(val); });
    };
    UpdateEl.prototype.onStandartTextareaChange = function (e) {
        var linkProjectId = extractProjectId(e.target.value);
        if (e.target.value.length < 2400) {
            this.setState({
                text: e.target.value,
                linkProjectId: linkProjectId
            });
        }
        if (e.target.value.length >= 2400) {
            this.props.toasts.error('Максимальная длина: 2400 символов');
            this.setState({
                text: e.target.value.substring(0, 2400)
            });
        }
        if (this.state.text.length < 50) {
            this.setState({
                isFirstLetter: false,
                text: "".concat(e.target.value),
                firstLetter: ''
            });
        }
    };
    UpdateEl.prototype.onStandartTextareaResize = function (ev) {
        var _this = this;
        var height = ev.target.offsetHeight;
        var style = this.state.style;
        if (height > 150) {
            setTimeout(function () {
                return _this.setState({
                    color: colorObj.white,
                    isTitleOpened: false,
                    fontColor: colorObj.fonts.white,
                    isTextTooBig: true,
                    isColorChoose: false,
                    colorName: 'white',
                    style: style
                });
            });
        }
        if (height < 150) {
            if (this.state.prevColorStatus === 'white') {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: false,
                        isColorChoose: false,
                        colorName: 'white',
                        style: style
                    });
                });
            }
            else {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj[_this.state.prevColorStatus],
                        isTitleOpened: true,
                        fontColor: colorObj.fonts[_this.state.prevColorStatus],
                        isTextTooBig: false,
                        isColorChoose: true,
                        colorName: _this.state.prevColorStatus,
                        style: style
                    });
                });
            }
        }
    };
    UpdateEl.prototype.escFunction = function (event) {
        if (event.keyCode === 27) {
            // this.onBlueArea(event)
            this.props.toggleLongReadPostUpdate(0, false);
        }
    };
    UpdateEl.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('keydown', this.escFunction, false);
        document.addEventListener('mousedown', this.handleClickOutside);
        this.setBigImage();
    };
    UpdateEl.prototype.componentDidMount = function () {
        if (this.props.updateStatus === true &&
            this.state.style === 'image' &&
            (this.state.imageCaption !== '' || this.state.caption !== '')) {
            this.updatePostStatus('caption');
        }
        var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
        this.setState({ sliderControlsPlacer: sliderControlsPlacer });
    };
    UpdateEl.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = ['normal', 'colored']) === null || _a === void 0 ? void 0 : _a.includes(this.props.post.style)) &&
            !!((_b = this.state.buttons) === null || _b === void 0 ? void 0 : _b.length) && !this.state.buttonUpdated) {
            var type = ((_c = this.state.buttons) === null || _c === void 0 ? void 0 : _c[0]).type;
            this.setState({
                buttonUpdated: true,
                secondaryStyle: type === LINK_BUTTON_TYPE
                    ? BUTTON_TYPE['button-link']
                    : BUTTON_TYPE['button-anchor']
            });
        }
        if (((_d = [
            'colored',
            'normal_image',
            'normal',
            'normal_card',
            'normal_emblem'
        ]) === null || _d === void 0 ? void 0 : _d.includes(this.state.style)) &&
            !!((_e = this.state.linkProjectId) === null || _e === void 0 ? void 0 : _e.length)) {
            var field = ((_f = [
                'colored',
                'normal_image',
                'normal',
                'normal_card',
                'normal_emblem'
            ]) === null || _f === void 0 ? void 0 : _f.includes(this.state.style)) ? 'text' : 'linkText';
            this.replaceHiddenProjectLink(this.state.linkProjectId, field);
        }
    };
    UpdateEl.prototype.componentDidMount = function () {
        var _a, _b, _c;
        if (this.props.post.style === 'normal') {
            var type = !!((_a = this.props.post.attachments) === null || _a === void 0 ? void 0 : _a.length) ? 'normal_image' :
                !!((_b = getCardIdsFromAdditionalInfo(this.state.additionalInfo)) === null || _b === void 0 ? void 0 : _b.length) ? 'normal_card' : 'normal';
            this.setState(__assign({ style: type }, (((_c = ['normal_card', 'normal_image']) === null || _c === void 0 ? void 0 : _c.includes(type)) && { text: this.props.post.text })));
        }
    };
    UpdateEl.prototype.componentWillUnmount = function () {
        this.uppy.close();
        this.props.toggleMobileEditor && this.props.toggleMobileEditor(false);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('keydown', this.escFunction, false);
    };
    UpdateEl.prototype.setSizes = function () {
        var innerWidth = window.innerWidth;
        // отступ цветного блока
        if (this.coloredTA.current !== null) {
            var textHeight = this.coloredTA.current.offsetHeight;
            this.setPaddings(textHeight, innerWidth);
        }
    };
    UpdateEl.prototype.setPaddings = function (textHeight, innerWidth) {
        var paddingsCurrent, heightsCurrent, calculatedHeightStyle;
        // проверяем ширину экрана
        if (innerWidth > MEDIA_QUERY) {
            paddingsCurrent = paddings.max;
            heightsCurrent = heights.max;
        }
        else {
            paddingsCurrent = paddings.min;
            heightsCurrent = heights.min;
        }
        // выставляем нужный паддинг
        calculatedHeightStyle = Math.round(textHeight / heightsCurrent);
        if (calculatedHeightStyle >= 4) {
            calculatedHeightStyle = 4;
        }
        this.setState({
            coloredPadding: paddingsCurrent[calculatedHeightStyle]
        });
    };
    UpdateEl.prototype.addFile = function (event, style) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, toasts, profile, isCover, isPodcast, files, appName, allowed, _c, fr_1;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = this.props, toasts = _b.toasts, profile = _b.profile;
                        isCover = style === 'as_cover';
                        isPodcast = style === 'podcast';
                        files = isPodcast ? (_a = Array.from(event.target.files)) === null || _a === void 0 ? void 0 : _a.slice(0, 1) : Array.from(event.target.files);
                        appName = getAppNameFromAppString(this.props.appName);
                        _c = ['geograffee', 'deziiign', 'competition'].includes(appName);
                        if (!_c) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadValidator({
                                files: files,
                                toasts: toasts,
                                isWideImageType: isCover,
                                profile: profile,
                                style: style,
                                isLMS: this.props.isLMS
                            })];
                    case 1:
                        _c = (_d.sent());
                        _d.label = 2;
                    case 2:
                        allowed = _c;
                        if (!allowed) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        if (style !== 'slider' && style !== 'two_pictures' && style !== 'tile') {
                            fr_1 = new FileReader();
                            this.uppy.reset();
                            files.forEach(function (file) {
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr_1.onload = function () {
                                    var _a, _b;
                                    if (style === 'small') {
                                        _this.setState({
                                            prevImageSrc: fr_1.result
                                        });
                                    }
                                    if (isPodcast) {
                                        _this.setState({
                                            text: ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.name) || '',
                                            audioSrc: fr_1.result,
                                            post: __assign(__assign({}, _this.state.post), { text: ((_b = files[0]) === null || _b === void 0 ? void 0 : _b.name) || '' })
                                        });
                                    }
                                    if (['big', 'image', 'as_cover', 'normal_image', 'normal_emblem'].includes(style)) {
                                        _this.setState({
                                            bigImageSrc: fr_1.result,
                                            style: style,
                                            isColorChoose: true,
                                            color: '#00000000'
                                        });
                                    }
                                };
                                fr_1.readAsDataURL(files[0]);
                            });
                        }
                        if (style === 'slider' || style === 'two_pictures' || style === 'tile') {
                            this.uppy.reset();
                            files.forEach(function (file, i) {
                                var fr = new FileReader();
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr.onload = function () {
                                    var _a;
                                    var newImg = (_a = __spreadArray([], _this.state.multiLoadGrouppedImg, true)) === null || _a === void 0 ? void 0 : _a.map(function (img) {
                                        if ((img === null || img === void 0 ? void 0 : img.name) === (file === null || file === void 0 ? void 0 : file.name) && !(img === null || img === void 0 ? void 0 : img.files)) {
                                            return __assign(__assign({}, img), { src: fr.result });
                                        }
                                        return img;
                                    });
                                    _this.setState({
                                        multiLoadGrouppedImg: newImg
                                    });
                                };
                                fr.readAsDataURL(file);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    UpdateEl.prototype.closeChooser = function () {
        this.setState({
            isColorChoose: false,
            isTitleOpened: false,
            color: colorObj.white,
            fontColor: colorObj.fonts.white,
            // color: colorObj['white'],
            colorName: 'white',
            style: 'normal',
            prevColorStatus: 'white'
        });
    };
    UpdateEl.prototype.onFocusArea = function (e) {
        e.target.setSelectionRange(e.target.value.length, e.target.value.length);
    };
    UpdateEl.prototype.addText = function (e) {
        var _this = this;
        if (e.target.value.length < 300) {
            this.setState({
                text: e.target.value
            });
        }
        if (e.target.value.length >= 300) {
            this.setState({
                text: e.target.value.substring(0, 298)
            }, function () {
                if (_this.state.text.length >= 300) {
                    _this.setState({
                        text: e.target.value.substring(0, 298)
                    });
                }
            });
        }
    };
    UpdateEl.prototype.cancelUpdate = function () {
        this.props.toggleLongReadPostUpdate(0, false);
    };
    UpdateEl.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        var _3 = this.state, style = _3.style, postTextPos = _3.postTextPos;
        var isSlider = style === 'slider' || style === 'tile';
        var isTwoPictures = style === 'two_pictures';
        var isProjects = style === 'projects';
        var isMultiLoadDisabled = (_a = this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.every(function (img) { return img.isUploaded; });
        var canSaveWPimage = !(this.state.style === 'normal_image' && (!((_c = (_b = this.state.post) === null || _b === void 0 ? void 0 : _b.attachments) === null || _c === void 0 ? void 0 : _c.length) || this.state.text.length === 0));
        var canSaveWPcard = !(this.state.style === 'normal_card' && (((_f = (_e = (!((_d = this.state.additionalInfo) === null || _d === void 0 ? void 0 : _d.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })))) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.length) || ((_g = this.state.text) === null || _g === void 0 ? void 0 : _g.length) === 0));
        var isDisabled = this.state.disablePosting || (this.state.style === 'podcast' ? ((_h = this.state.post.text) === null || _h === void 0 ? void 0 : _h.length) === 0 : this.state.style === 'course_lesson'
            ? this.state.lessonPostDisabled
            : (this.state.style === 'projects' || this.state.style === 'course_presentation')
                ? ((_j = this.state.projectIds) === null || _j === void 0 ? void 0 : _j.length) === 0
                : (this.state.style === 'products' || this.state.style === 'card')
                    ? !((_k = getCardIdsFromAdditionalInfo(this.state.additionalInfo)) === null || _k === void 0 ? void 0 : _k.length)
                    : isSlider
                        ? (((_l = this.state.multiLoadGrouppedImg) === null || _l === void 0 ? void 0 : _l.length) < 2 || ((_m = this.state.multiLoadGrouppedImg) === null || _m === void 0 ? void 0 : _m.length) > MAX_FILES_COUNT)
                        : isTwoPictures
                            ? ((((_o = this.state.multiLoadGrouppedImg) === null || _o === void 0 ? void 0 : _o.length) !== 2) || !isMultiLoadDisabled)
                            : (!canSaveWPcard || !canSaveWPimage) ? true
                                : (this.state.style === 'forms') ? false
                                    : !!((this.state.text.length === 0 &&
                                        this.props.post.attachments.length === 0) ||
                                        this.state.isLoading));
        var _4 = this.props, colorStyle = _4.colorStyle, _5 = _4.post, postId = _5.postId, userId = _5.userId, longreadId = _5.longreadId, t = _4.t;
        var caption = this.state.caption;
        var captionColorStyle = 'light';
        var additionalStyle = this.state.secondaryStyle;
        var attachment = this.props.post.attachments.length && this.props.post.attachments[0] ? this.props.post.attachments[0] : null;
        var titlePosition = this.state.postTextPos || 'inside';
        var showVotesCollection = !!((_p = this.props.votesContent) === null || _p === void 0 ? void 0 : _p.isCollectionVote);
        var buttons = ((_q = this.props.post) === null || _q === void 0 ? void 0 : _q.buttons) || [];
        var bigImageUrl = "";
        if (attachment) {
            var file = attachment.file ? attachment.file : attachment.files[0];
            if (file)
                bigImageUrl = "".concat(urlApi().getImageQueryLink()).concat(file.url);
        }
        var isImage = ['image', 'big', 'as_cover'].includes(style);
        var isLMS = this.props.isLMS;
        var isRibbon = this.state.isRibbon;
        var isPresentation = (style === 'as_cover' || this.props.post.style === 'as_cover') && this.props.isPresentation;
        var updatePortal = !!((_r = (this.state.bigImageSrc || bigImageUrl)) === null || _r === void 0 ? void 0 : _r.length);
        var ratingEditorVisible = !!this.state.useRating;
        var isFirstCover = this.state.style === 'as_cover' && !isPresentation;
        var isSpVote = this.state.style === 'super-puper-vote';
        var editingCaption = this.props.updateStatus === 'caption' &&
            ['image', 'slider', 'projects', 'two_pictures', 'tile'].includes(style);
        var isImageCaptionSetted = this.state.style === 'image' && this.state.imageCaption !== '';
        var isBigImageTextSetted = this.state.style === 'big' && this.state.text !== '';
        var isForPay = getIsPayFromPost(this.state);
        var currentActiveCaption = (isImageCaptionSetted || (isSlider && this.state.multiLoadCaptionMode === 'small')) ? 'small-caption' : (isBigImageTextSetted || (isSlider && this.state.multiLoadCaptionMode === 'big')) ? 'big-caption' : null;
        var hideBackground = isPresentation; /*&& (this.state.postTextPos === 'outside' || !!this.props.editorComponent)*/
        var toasts = this.props.toasts;
        var appName = getAppNameFromAppString(this.props.appName);
        var isGallllery = ['gallllery'].includes(appName);
        // console.log(`FIX WIDTH: ${this.props.isPresentation || isSlider}`)
        // console.log('pooplist2', this.state.multiLoadGrouppedImg);
        var isBottom = !isImage && !isFirstCover && !isSpVote && !isSlider && !isPresentation && !isProjects && !isTwoPictures;
        var isTop = (isImage && !isFirstCover) || isSlider || isPresentation || isProjects || isTwoPictures;
        var textValue = !((_s = this.state.text) === null || _s === void 0 ? void 0 : _s.length) ? this.state.caption : !((_t = this.state.caption) === null || _t === void 0 ? void 0 : _t.length) ? this.state.text : this.state.text;
        var cardIds = getCardIdsFromAdditionalInfo(this.state.additionalInfo);
        var editorToolbar = (React.createElement(EditorToolbar, { typeConnection: this.props.typeConnection, position: isBottom ? 'bottom' : isTop ? 'top' : 'none', style: style, bookId: this.props.bookId, isForPay: isForPay, cardId: (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 ? cardIds[0] : this.props.post.cardId, includedCards: this.props.includedCards, editing: true, variant: 'update', editingCaption: editingCaption, onAdditionalStyleDelete: this.handleChangeAdditionalStyle, onClose: function () { return _this.props.toggleLongReadPostUpdate(0, false); }, isPresentation: isPresentation, postTextPos: this.state.postTextPos, hasImage: isImage, postWithRaiting: this.state.useRating, multiLoadCaptionMode: this.state.multiLoadCaptionMode, colorPickerComponent: React.createElement(React.Fragment, null, (style === 'colored' || style === "link" || style === 'annotation') && (React.createElement(ColorMenuComp, { color: this.state.color, closeChooser: this.closeChooser, chooseColor: this.chooseColor, bigimageRef: this.bigimageRef, addFile: this.addFile, clickedAction: this.updateLongReadPost, isDisabled: isDisabled, style: 'update', canceledAction: this.cancelUpdate, postStyle: this.state.style, src: this.state.bigImageSrc }))), onAddImage: this.addFile, onAddForms: this.handleAddForms, onAddCard: this.handleCardButton, onAddLesson: this.handleAddLesson, onAddPodcast: this.handleAddPodcast, onAddProduct: this.handleProductsButton, onAddCoursePresentation: this.handleAddCoursePresentation, onButtonsDelete: this.handleDeleteButton, onAddProjects: this.handleProjects, onTogglePostLikes: this.handleTogglePostLikes, fileRef: this.fileRef, onSubmit: style === 'course_lesson' ? this.updateLongReadLessonPost : this.updateLongReadPost, postDisabled: isDisabled, onAddButtonLink: this.handleButtonLink, onAddAnchorButton: this.handleAnchorButton, additionalStyle: additionalStyle, onAddTitlePost: this.handleTitleBlock, onAddCaption: function (position) {
                _this.updatePostStatus('caption');
                if (!isSlider && !isPresentation && !isProjects) {
                    _this.setState({ style: 'image', postTextPos: 'caption-bottom' });
                }
                if (isPresentation) {
                    _this.setState({
                        postTextPos: position
                    });
                }
                if (isSlider) {
                    _this.setState({
                        multiLoadCaptionMode: 'small'
                    });
                }
            }, onAddText: this.handleAddText, onAddWhitePost: function () { return _this.setState({ style: 'normal' }); }, onAddWhitePostImages: this.handleWhitePostImageButton, onAddColoredPost: function () {
                var hex = _this.state.color || '#2A3034';
                _this.setState({
                    style: 'colored',
                    color: _this.state.color || '#2A3034',
                    colorName: 'black',
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                });
            }, onAddLinkPost: function () {
                var hex = _this.state.color || '#2A3034';
                _this.setState({
                    style: 'link',
                    color: _this.state.color || '#2A3034',
                    colorName: 'black',
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                    text: "".concat(_this.state.text),
                    linkText: _this.state.linkText
                });
            }, anchorText: this.state.anchorText, onAnchorChange: this.handleAnchorChange, onAddSlider: function () { }, onAddVideo: function () { return _this.setState({ style: 'video' }); }, onAddAudio: function () { return _this.setState({ style: 'audio' }); }, onAddImageSources: function () { return _this.setState({ style: 'image_sources' }); }, onAddBibliography: function () { return _this.setState({ style: 'bibliography' }); }, appName: this.props.appName, additionalInfo: this.state.additionalInfo, onToggleWidePreviewer: this.handleTogglePreviewer, setAdditionalInfo: function (additionalInfo) {
                _this.setState({ additionalInfo: additionalInfo });
            }, currentActiveCaption: currentActiveCaption, setSliderControlsPlacer: function () {
                var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
                _this.setState({ sliderControlsPlacer: sliderControlsPlacer });
            }, isDropdownOpen: this.state.isDropdownOpen }));
        return (React.createElement(React.Fragment, null,
            (this.state.style === "image_sources" || this.state.style === "bibliography") && React.createElement(FlexBox, { width: '100%', justify: "center" },
                React.createElement(UpdateHeaderToggle, { colorStyle: colorStyle, viewType: this.props.viewType }, t('editor.' + this.state.style))),
            React.createElement(Wrap, { isGalllleryNewStyle: isGallllery, updateStatus: this.props.updateStatus, ref: this.wrapperRef, withHeader: this.state.style === "image_sources" || this.state.style === "bibliography", index: this.props.index, hideBackground: hideBackground, fixWidth: this.props.isPresentation || isSlider || isLMS, blocksLength: this.props.blocksLength, zIndex: this.props.isDragging
                    ? 800
                    : Math.max(1, this.props.blocksLength + 3 - this.props.index) },
                isTop && editorToolbar,
                editingCaption && (React.createElement(CaptionEdit, { value: textValue, onSubmit: function (value) { return _this.setCaption(value); }, onCancel: function () { return _this.updatePostStatus(false); } })),
                this.state.style === 'big' || this.state.style === 'image' ? (React.createElement(React.Fragment, null,
                    additionalStyle !== '' && (React.createElement(ButtonBlock, { data: buttons, uprise: UPRISE_TYPE.dropdown, type: additionalStyle, onAddNewButton: this.handlePostButtonsChange, isEdited: true, setDropdownOpen: this.setDropdownOpen })),
                    React.createElement(BigImageComp, { userId: (_u = this.props.post) === null || _u === void 0 ? void 0 : _u.userId, isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc || bigImageUrl, TAvalue: textValue, TAOnChange: this.addText, style: this.state.style, postId: (_v = this.props.post) === null || _v === void 0 ? void 0 : _v.postId, cardId: (_w = this.props.post) === null || _w === void 0 ? void 0 : _w.cardId, textPosition: postTextPos }))) : style === 'card' ? (React.createElement(BigImageCard, { userId: (_x = this.props.post) === null || _x === void 0 ? void 0 : _x.userId, isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc || bigImageUrl, TAvalue: textValue, TAOnChange: this.addText, style: this.state.style, postId: (_y = this.props.post) === null || _y === void 0 ? void 0 : _y.postId, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo), textPosition: postTextPos })) : ((_z = ['annotation', 'block_with_title']) === null || _z === void 0 ? void 0 : _z.includes(this.state.style)) ? (React.createElement(BlockWithTitleEdit, { ref: this.coloredTextareaRef, onChange: function (e) { return _this.onColoredTextareaResize(e); }, onCaptionChange: function (e) { return _this.onCaptionChange(e); }, 
                    // onFocus={(e) => this.onFocusArea(e)}
                    text: this.state.text, style: this.state.style, caption: this.state.caption, bgcolor: this.state.color, fontColor: this.state.fontColor })) : this.state.style === 'colored' ? (React.createElement(EditTitle, { bgcolor: this.state.color, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, viewType: this.props.viewType },
                    React.createElement("div", { ref: this.coloredTextareaRef },
                        React.createElement(TextArea, { value: this.state.text.substring(0, 2400), onChange: function (e) { return _this.onColoredTextareaResize(e); }, placeholder: t('editor.inputs.placeholder'), 
                            // onResize={this.onColoredTextareaResize}
                            ref: this.coloredTA, postType: this.state.style, onFocus: function (e) { return _this.onFocusArea(e); }, autoFocus: true }),
                        additionalStyle !== '' && (React.createElement(ButtonBlock, { data: buttons, uprise: UPRISE_TYPE.colored, type: additionalStyle, onAddNewButton: this.handlePostButtonsChange, isEdited: true, setDropdownOpen: this.setDropdownOpen }))),
                    ratingEditorVisible && (React.createElement(RaitingBox, { onChange: this.handleToggleRatingDataChange, data: this.state.ratings })))) : this.state.style === 'link' ? (React.createElement(EditTitle, { bgcolor: this.state.color, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, viewType: this.props.viewType, isLinkBlock: true },
                    React.createElement("div", { ref: this.coloredTextareaRef },
                        React.createElement(LinkArea, { value: this.state.text, onChange: function (e) { return _this.onLinkResize(e); }, linkText: this.state.linkText, onLinkChange: function (linkText) { return _this.handleSetLink(linkText); }, placeholder: t('editor.inputs.link_placeholder'), ref: this.coloredTA, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, fontColor: this.state.fontColor, bgcolor: this.state.color, autoFocus: true, resize: false }),
                        additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.colored, onAddNewButton: this.handlePostButtonsChange, setDropdownOpen: this.setDropdownOpen }))))) : (this.state.style === "image_sources" || this.state.style === "bibliography") ? (React.createElement("div", null,
                    React.createElement(EditorWrap, { onClick: this.handleTextareaFocus },
                        React.createElement(TextWrapper, null,
                            React.createElement(LeftColumn, { isBiblio: true },
                                React.createElement(FlexBox, { direction: "column", directionMobile: "column", offsetLeft: 36, gy: 16 },
                                    (!this.props.alreadyHasBibliography || this.state.style === 'bibliography') && React.createElement(RadioButton, { checked: this.state.style === 'bibliography', onChange: function () {
                                            _this.setState({ style: 'bibliography' });
                                        }, name: 'bibliography' },
                                        React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.bibliography'))),
                                    (!this.props.alreadyHasImageSources || this.state.style === 'image_sources') && React.createElement(RadioButton, { checked: this.state.style === 'image_sources', onChange: function () {
                                            _this.setState({ style: 'image_sources' });
                                        }, name: 'image_sources' },
                                        React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.image_sources'))))),
                            React.createElement(RightColumn, null,
                                React.createElement("div", { ref: this.textareaRef },
                                    React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onSourcesTextareaChange(e); }, onKeyUp: function (e) { return _this.onSourcesTextareaKeyUp(e); }, placeholder: t('editor.inputs.placeholder'), onResize: this.onSourcesTextareaChange, maxLength: this.state.style === 'image_sources' ? 100000 : 50000, onFocus: function (e) { return _this.onFocusArea(e); }, type: TEXTAREA_TYPE.bibliography, autoFocus: true }))))))) : this.state.style === 'as_cover' ? (React.createElement(React.Fragment, null, isPresentation ? (React.createElement(PresentationBlock, { theme: this.props.theme, blocksLength: this.props.blocksLength, colorStyle: colorStyle, src: this.state.bigImageSrc || bigImageUrl, fileRef: this.fileRef, onAddImage: this.addFile, TAvalue: this.state.text, TAOnChange: this.addText, postDisabled: isDisabled, isEditingCaption: editingCaption, postTextPos: titlePosition, updatePortal: updatePortal, onPresentationHeaderChange: (_0 = this.props) === null || _0 === void 0 ? void 0 : _0.onPresentationHeaderChange, editorComponent: this.props.editorComponent, onSubmit: this.updateLongReadPost, isUpdate: true })) : (React.createElement(FirstAsCoverBlock, { src: this.state.bigImageSrc || bigImageUrl, onAddImage: this.addFile, fileRef: this.fileRef, onSubmit: this.updateLongReadPost, postDisabled: isDisabled })))) : this.state.style === 'super-puper-vote' ? (React.createElement(React.Fragment, null, showVotesCollection ? (React.createElement(Votepostwithcollect, { post: this.props.post, toggleLongReadPostUpdate: toggleLongReadPostUpdate, imgRef: this.imageRef, isUpdatePost: true, votesContent: this.props.votesContent, 
                    // dragHandleProps={dragHandleProps}
                    // isDragging={isDragging}
                    // isDragContinue={isDragContinue}
                    // isEditable={isEditable}
                    // linkTo={linkTo}
                    // colorStyle={colorStyle}
                    viewType: this.props.viewType })) : (React.createElement(VotePostBlock, { post: this.props.post, toggleLongReadPostUpdate: toggleLongReadPostUpdate, imgRef: this.imageRef, isUpdatePost: true, votesContent: this.props.votesContent, 
                    // dragHandleProps={dragHandleProps}
                    // isDragging={isDragging}
                    // isDragContinue={isDragContinue}
                    // isEditable={isEditable}
                    // linkTo={linkTo}
                    // colorStyle={colorStyle}
                    viewType: this.props.viewType })))) : style === 'two_pictures' ? (React.createElement(TwoPicturesBlock, { isLoading: !isMultiLoadDisabled, srcList: this.state.multiLoadGrouppedImg, onSlideTextChange: this.handleSlideTextChange, onChange: this.handleSortedMultipleImgChange, onChangeImage: this.onChangeImage, textPosition: this.state.postTextPos, controlsPlacer: this.state.sliderControlsPlacer, caption: textValue, fileRef: this.imageRef, onCaptionEdit: function () {
                        _this.updatePostStatus('caption');
                        _this.setState({
                            postTextPos: 'caption-bottom'
                        });
                    }, isEditable: true })) : (this.state.style === 'slider' || this.state.style === 'tile') ? (React.createElement(SliderEditBlock, { srcList: this.state.multiLoadGrouppedImg, isUpdatePost: true, style: style, viewType: this.props.viewType, TAvalue: textValue, TAOnChange: this.handleTextPositionChange, onImgRemove: this.handleImgRemove, handleSlideChecked: this.handleSlideChecked, onTileViewTypeChange: this.handleTileViewTypeChange, isRibbon: isRibbon, onSlideTextChange: this.handleSlideTextChange, onSetSortedImg: this.handleSortedMultipleImgChange, editingText: this.state.editingText, captionMode: this.state.multiLoadCaptionMode, textPosition: this.state.postTextPos, controlsPlacer: this.state.sliderControlsPlacer, caption: textValue, tileViewType: this.state.tileViewType })) : style === 'projects' ? (React.createElement(ProjectEditBlock, { style: style, projectIds: this.state.projectIds, onSetSortedProject: this.handleSortedProjects, onDeleteProject: this.handleDeleteProjects })) : style === 'products' ? (React.createElement(ProductsBlock, { style: style, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo), onChange: this.handleProductsChange, onSetSortedProject: this.handleSortedProjects, onDeleteProject: this.handleDeleteProjects, isEditable: true })) : style === 'course_presentation' ? (React.createElement(CoursePresentationEditBlock, { style: style, onSelect: this.handleSetCoursePresentation, selectedProject: this.state.projectIds })) : this.state.style === 'forms' ? (React.createElement(FormsBlock, { post: this.props.post, isUpdatePost: true, isDisabled: true, colorStyle: colorStyle, isLoading: this.state.isLoading, onSetFormPosition: this.handleSetFormPosition, onFormIdSet: this.handleSetFormId })) : this.state.style === 'course_lesson' ? (React.createElement(LessonEditBlock, { post: this.props.post, lessonId: this.state.text, isLoading: this.state.isLoading, onSubmit: function (text) { return _this.setState({ text: text }); }, setLessonPostDisabled: function (lessonPostDisabled) { return _this.setState({ lessonPostDisabled: lessonPostDisabled }); }, setOnLessonSave: function (onLessonSave) { return _this.setState({ onLessonSave: onLessonSave }); } })) : this.state.style === 'podcast' ? (React.createElement(PodcastEditBlock, { podcastTimecodes: JSON.parse(getAdditionalInfoVal(this.state.additionalInfo, 'podcastTimeCodes') || "[]"), isLoading: this.state.isLoading, audioSrc: this.state.post.audioSrc, podcastName: this.state.post.text, isNewPost: !this.state.post.postId, onClearPodcastFile: function () {
                        _this.setState({
                            post: __assign(__assign({}, _this.state.post), { text: '', audioSrc: '' })
                        });
                        if (_this.fileRef.current)
                            _this.fileRef.current.value = '';
                    }, onSetPodcastTimeCodes: function (podcastTimeCodes) {
                        _this.setState({
                            post: __assign(__assign({}, _this.state.post), { additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTimeCodes", "value": JSON.stringify(podcastTimeCodes) }]) }),
                            additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTimeCodes", "value": JSON.stringify(podcastTimeCodes) }])
                        });
                    }, onSetPodcastTotalTime: function (podcastTime) {
                        _this.setState({
                            post: __assign(__assign({}, _this.state.post), { additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTime", "value": String(podcastTime) }]) }),
                            additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTime", "value": String(podcastTime) }])
                        });
                    }, fileRef: this.fileRef, onAddImage: this.addFile })) : (React.createElement("div", null,
                    React.createElement(EditorWrap, { onClick: this.handleTextareaFocus },
                        React.createElement(TextWrapper, { isEmblem: this.state.style === 'normal_emblem' },
                            React.createElement(LeftColumn, { isEdit: true, className: 'left-column' },
                                React.createElement(WhitePostImageBlock, { fileRef: this.fileRef, uppy: this.uppy, style: style, isUpdate: true, onAddCard: this.handleUpdateWhitePostCard, onAddImage: this.addFile, onImageRemove: function () { return _this.onImageRemove(); }, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo), src: this.state.bigImageSrc, post: this.state.post })),
                            React.createElement(RightColumn, { className: 'right-column' },
                                React.createElement("div", { ref: this.textareaRef },
                                    React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onStandartTextareaChange(e); }, placeholder: t('editor.inputs.placeholder'), onResize: this.onStandartTextareaResize, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, maxLength: '2400' // old value = 1000
                                        , autoFocus: true }),
                                    additionalStyle !== '' && (React.createElement(ButtonBlock, { data: buttons, uprise: UPRISE_TYPE.normal, type: additionalStyle, onAddNewButton: this.handlePostButtonsChange, onDeleteButton: this.handleDeleteButton, postId: (_1 = this.props.post) === null || _1 === void 0 ? void 0 : _1.postId, isEdited: true, setDropdownOpen: this.setDropdownOpen }))),
                                this.state.post.attachments.length > 0 ? (React.createElement("div", null, ((_2 = this.state.post.attachments[0].file) === null || _2 === void 0 ? void 0 : _2.isDeleted) ===
                                    false ? (React.createElement(AttachmentsWrap, null,
                                    React.createElement(AttachedImage, { isLoading: this.state.isLoading },
                                        React.createElement("label", null,
                                            React.createElement("img", { src: bigImageUrl, alt: 'prev' }),
                                            React.createElement("div", { className: 'image__hover' }, "Replace Image"),
                                            React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: this.imageRef, onChange: function (e) { return _this.addFile(e, 'small'); } }))),
                                    React.createElement(RemoveImage, { onClick: function () { return _this.onImageRemove(); } }))) : (''))) : (''),
                                this.state.prevImageSrc === '' ? ('') : (React.createElement(AttachmentsWrap, null,
                                    React.createElement(AttachedImage, { isLoading: this.state.isLoading },
                                        React.createElement(AttachedImageProgress, { isLoading: this.state.isLoading },
                                            React.createElement(ProgressBar, { uppy: this.uppy, hideAfterFinish: true })),
                                        React.createElement("label", null,
                                            React.createElement("img", { src: this.state.prevImageSrc, alt: 'prev' }),
                                            React.createElement("div", { className: 'image__hover' }, "Replace Image"),
                                            React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: this.imageRef, onChange: function (e) { return _this.addFile(e, 'small'); } }))),
                                    React.createElement(ImageCaption, null,
                                        React.createElement(TextArea, { value: this.state.imageCaption, onChange: function (e) {
                                                return _this.setState({ imageCaption: e.target.value });
                                            }, placeholder: t('editor.add_caption_placeholder') })),
                                    React.createElement(RemoveImage, { onClick: function () { return _this.onImageRemove(); } })))))))),
                isBottom && editorToolbar),
            caption && postTextPos === 'caption-bottom' && (React.createElement(CaptionBlock, { colorStyle: captionColorStyle },
                React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(caption))))));
    };
    return UpdateEl;
}(Component));
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var toggleLongReadPostUpdate = getToggleLongReadPostUpdate(store, currentId);
    var newLongread = getCurrentLongread(store, currentId);
    return {
        // countryInnerPageData: store.countryInnerPage.data,
        updateStatus: toggleLongReadPostUpdate.updateStatus,
        alreadyHasImageSources: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'image_sources'; })
            : false,
        alreadyHasBibliography: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'bibliography'; })
            : false,
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var currentId = _a.lgid;
    return {
        // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
        addLongReadPost: function (_a) {
            var id = _a.id, title = _a.title, text = _a.text, color = _a.color, imageid = _a.imageid, lgid = _a.lgid, generalProps = _a.generalProps;
            return dispatch(addLongReadPost({ id: id, title: title, text: text, color: color, imageid: imageid, lgid: lgid, generalProps: generalProps }));
        },
        getLongReadPosts: function (idUser, idLongRead, sign, thematic) {
            return dispatch(getLongReadPosts(idUser, idLongRead, sign, thematic));
        },
        toggleLongReadPostUpdate: function (postid, updateStatus) {
            return dispatch(toggleLongReadPostUpdate(postid, updateStatus, currentId));
        },
        updateLongReadPost: function (imageid, post) {
            return dispatch(updateLongReadPost(imageid, post));
        },
        deleteLongReadPost: function (id, idUser, idLongRead, sign) {
            return dispatch(deleteLongReadPost(id, idUser, idLongRead, sign));
        },
        toggleWidePreviewer: function (val, src) {
            return dispatch(toggleWidePreviewer(val, src));
        },
        clearWidePreviewer: function () {
            return dispatch(clearWidePreviewer());
        }
    };
};
UpdateEl.propTypes = {};
export default connect(mapStateToProps, mapDispatchToProps)(toastHook(withProfile(withModal(withLocalization(UpdateEl))), useToasts));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
/*

<ImageCaption>
                                <TextareaAutosize value={this.state.imageCaption}
                                                  onChange={(e) => this.setState({ imageCaption: e.target.value })}
                                                  placeholder='Add caption'
                                />
                              </ImageCaption>



                      {
                        this.state.text.length > 50 && this.state.isFirstLetter ?
                        <RemoveLetterBtn onClick={() => this.toggleFirstLetter(false)} /> :
                        this.state.text.length > 50 && !this.state.isFirstLetter ?
                        <AddLetterBtn onClick={() => this.toggleFirstLetter(true)} /> :
                        ''
                      }
*/
/*
const uppy = new Uppy({
  meta: { type: 'image/jpeg' },
  restrictions: { maxNumberOfFiles: 1 },
  autoProceed: true
})

uppy.use(Tus, { endpoint: 'https://test5.swarm.store/upload/' })
*/
/*
Старый дизайн


const Top = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`

const Bottom = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;
`

const ButtonClose = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${close}) no-repeat center;
`

const ButtonAddImage = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addimage}) no-repeat center;
`

const ButtonAddVideo = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addvideo}) no-repeat center;
`

const ButtonAddPubl = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addpubl}) no-repeat center;
`

const ButtonAddWide = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addwide}) no-repeat center;
`

const ButtonAddSection = styled.div`
  width: 55px;
  height: 55px;
  margin-right: 15px;
  cursor: pointer;
  background: url(${addsection}) no-repeat center;
`

const Border = styled.div`
  width: 2px;
  height: 66px;
  margin-right: 15px;
  background: white;
`

const SectionNameText = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 63px;
  line-height: 72px;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  margin-bottom: 15px;
`
const SelectName = styled.div`
  color: black;
  display: inline-block;
  position: relative;
  cursor: pointer;
  &:after {
    content: '';
    display: inline-block;
    position: relative;
    width: 22px;
    height: 22px;
    background: url(${arr}) no-repeat center;
    top: -10px;
    margin-left: 10px;
  }
`



*/
//# sourceMappingURL=updateel.js.map